import React, { useState, useEffect, useCallback } from 'react';
import { unduhPdf } from './unduhPdf';
import ProfilLengkapUser from './ProfilLengkapUser';
import { MODUL_DASAR } from './TryoutScreen';
import { modulBaruAktif, MODUL_BARU_IDS } from './modulBaruConfig';

const API_URL = 'https://skortes.com';

// ─── Helper API ───────────────────────────────────────────────
async function apiCall(endpoint, method = 'GET', body = null, token = null) {
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  const res = await fetch(`${API_URL}${endpoint}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : null,
  });
  return res.json();
}

// ─── Layar Login Admin ────────────────────────────────────────
function LoginAdmin({ onLogin }) {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);

  const handleLogin = async () => {
    setLoading(true);
    setError('');
    try {
      const data = await apiCall('/api/login', 'POST', { email, password });
      if (data.token && data.user.role === 'admin') {
        localStorage.setItem('adminToken', data.token);
        localStorage.setItem('adminUser', JSON.stringify(data.user));
        onLogin(data.token, data.user);
      } else if (data.token && data.user.role !== 'admin') {
        setError('Akun ini bukan akun admin.');
      } else {
        setError(data.error || 'Login gagal');
      }
    } catch {
      setError('Tidak bisa terhubung ke server');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: 'var(--bg-app)' }}>
      <div className="w-full max-w-sm p-8 rounded-2xl" style={{ backgroundColor: 'var(--bg-card)', border: '1px solid var(--border)' }}>
        <div className="text-center mb-8">
          <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" style={{ backgroundColor: 'var(--accent)' }}>
            <span className="text-2xl">📊</span>
          </div>
          <h1 className="text-2xl font-bold" style={{ color: 'var(--text-primary)', fontFamily: "'Poppins', sans-serif" }}>
            ADMIN PANEL
          </h1>
          <p className="text-sm mt-1" style={{ color: 'var(--text-muted)' }}>Skortes</p>
        </div>

        {error && (
          <div className="mb-4 px-4 py-3 rounded-xl text-sm" style={{ backgroundColor: 'rgba(220,38,38,0.1)', color: 'var(--danger)', border: '1px solid var(--danger)' }}>
            {error}
          </div>
        )}

        <div className="space-y-4">
          <div>
            <p className="text-xs uppercase tracking-wider mb-1.5" style={{ color: 'var(--text-muted)' }}>Email Admin</p>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)}
              placeholder="admin@tnipsikotes.com"
              className="w-full px-4 py-3 rounded-xl text-sm focus:outline-none"
              style={{ backgroundColor: 'var(--bg-card2)', color: 'var(--text-primary)', border: '1px solid var(--border)' }}
            />
          </div>
          <div>
            <p className="text-xs uppercase tracking-wider mb-1.5" style={{ color: 'var(--text-muted)' }}>Password</p>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              onKeyDown={e => e.key === 'Enter' && handleLogin()}
              className="w-full px-4 py-3 rounded-xl text-sm focus:outline-none"
              style={{ backgroundColor: 'var(--bg-card2)', color: 'var(--text-primary)', border: '1px solid var(--border)' }}
            />
          </div>
          <button onClick={handleLogin} disabled={loading}
            className="w-full py-3.5 rounded-xl font-bold text-sm uppercase tracking-wide mt-2"
            style={{ backgroundColor: 'var(--accent)', color: 'var(--bg-app)', fontFamily: "'Poppins', sans-serif", opacity: loading ? 0.7 : 1 }}>
            {loading ? 'Masuk...' : 'Masuk sebagai Admin →'}
          </button>
        </div>
      </div>
    </div>
  );
}

// ─── Kartu Statistik ──────────────────────────────────────────
function KartuStat({ icon, label, value, color }) {
  return (
    <div className="rounded-xl p-5" style={{ backgroundColor: 'var(--bg-card2)', border: '1px solid var(--border)' }}>
      <div className="flex items-center gap-3 mb-2">
        <span className="text-2xl">{icon}</span>
        <p className="text-xs uppercase tracking-wider" style={{ color: 'var(--text-muted)' }}>{label}</p>
      </div>
      <p className="text-3xl font-extrabold font-mono" style={{ color }}>{value}</p>
    </div>
  );
}

// ─── Dashboard ────────────────────────────────────────────────
function Dashboard({ token, stats }) {
  return (
    <div className="space-y-6">
      <h2 className="text-xl font-bold" style={{ color: 'var(--text-primary)', fontFamily: "'Poppins', sans-serif" }}>
        DASHBOARD
      </h2>
      <div className="grid grid-cols-2 gap-4">
        <KartuStat icon="👥" label="Total User" value={stats.totalUser || 0} color="var(--accent)" />
        <KartuStat icon="🏆" label="Total Tryout" value={stats.totalTryout || 0} color="#60A5FA" />
        <KartuStat icon="💳" label="Pembayaran" value={stats.totalPembayaran || 0} color="var(--success)" />
        <KartuStat icon="📝" label="Hasil Tryout" value={stats.totalHasil || 0} color="#F472B6" />
      </div>

      <div className="rounded-xl p-5" style={{ backgroundColor: 'var(--bg-card2)', border: '1px solid var(--border)' }}>
        <p className="text-sm font-bold mb-3" style={{ color: 'var(--accent)', fontFamily: "'Poppins', sans-serif" }}>
          📋 INFO SISTEM
        </p>
        <div className="space-y-2 text-sm" style={{ color: 'var(--text-muted)' }}>
          <div className="flex justify-between">
            <span>Backend</span>
            <span style={{ color: 'var(--success)' }}>● Online</span>
          </div>
          <div className="flex justify-between">
            <span>Database</span>
            <span style={{ color: 'var(--success)' }}>● Terhubung</span>
          </div>
          <div className="flex justify-between">
            <span>VPS IP</span>
            <span style={{ color: 'var(--text-primary)' }}>103.143.12.42</span>
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── Kelola User ──────────────────────────────────────────────
function KelolaUser({ token }) {
  const [users, setUsers]       = useState([]);
  const [loading, setLoading]   = useState(true);
  const [selected, setSelected] = useState(null); // user yang dipilih untuk detail
  const [lihatProfilId, setLihatProfilId] = useState(null); // user yang dibuka halaman profil lengkapnya

  const loadUsers = useCallback(() => {
    apiCall('/api/admin/users', 'GET', null, token)
      .then(data => { setUsers(data.users || []); setLoading(false); })
      .catch(() => setLoading(false));
  }, [token]);

  useEffect(() => { loadUsers(); }, [loadUsers]);

  if (lihatProfilId) {
    return <ProfilLengkapUser userId={lihatProfilId} token={token} onTutup={() => setLihatProfilId(null)} />;
  }

  const handleUbahRole = async (id, roleSekarang) => {
    const roleBaru = roleSekarang === 'admin' ? 'user' : 'admin';
    if (!window.confirm(`Ubah role user ini menjadi "${roleBaru}"?`)) return;
    await apiCall(`/api/admin/users/${id}/role`, 'PUT', { role: roleBaru }, token);
    loadUsers();
    setSelected(null);
  };

  const handleHapus = async (id, nama) => {
    if (!window.confirm(`Hapus akun "${nama}"? Tindakan ini tidak bisa dibatalkan.`)) return;
    await apiCall(`/api/admin/users/${id}`, 'DELETE', null, token);
    loadUsers();
    setSelected(null);
  };

  // Centang izin latihan harian: user yang sedang tryout (latihan harian biasanya
  // terkunci sampai tryout selesai) bisa mengerjakan modul harian kalau admin mencentang ini.
  const handleIzinLatihan = async (id, izinBaru) => {
    const res = await apiCall(`/api/admin/users/${id}/izin-latihan`, 'PUT', { izin: izinBaru }, token);
    if (res && res.error) { alert(res.error); return; }
    loadUsers();
  };

  const handleUbahJalur = async (id, jalur) => {
    const jalurBaru = jalur === 'tamtama' ? 'bintara' : 'tamtama';
    await apiCall(`/api/admin/users/${id}/jalur`, 'PUT', { jalur: jalurBaru }, token);
    loadUsers();
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-bold" style={{ color: 'var(--text-primary)', fontFamily: "'Poppins', sans-serif" }}>
          KELOLA USER
        </h2>
        <span className="text-sm px-3 py-1 rounded-full" style={{ backgroundColor: 'var(--bg-card3)', color: 'var(--accent)' }}>
          {users.length} akun
        </span>
      </div>

      {loading ? (
        <p className="text-center py-8" style={{ color: 'var(--text-muted)' }}>Memuat data user...</p>
      ) : users.length === 0 ? (
        <div className="text-center py-12 rounded-xl" style={{ backgroundColor: 'var(--bg-card2)', border: '1px solid var(--border)' }}>
          <p className="text-4xl mb-3">👥</p>
          <p style={{ color: 'var(--text-muted)' }}>Belum ada user terdaftar</p>
        </div>
      ) : (
        <div className="space-y-2">
          {users.map((u) => (
            <div key={u.id}>
              {/* Kartu user */}
              <div
                className="rounded-xl p-4 cursor-pointer transition"
                onClick={() => setSelected(selected?.id === u.id ? null : u)}
                style={{
                  backgroundColor: selected?.id === u.id ? 'var(--bg-card3)' : 'var(--bg-card2)',
                  border: `1px solid ${selected?.id === u.id ? 'var(--accent)' : 'var(--border)'}`
                }}>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 rounded-full flex items-center justify-center font-bold text-sm"
                         style={{ backgroundColor: u.role === 'admin' ? 'var(--bg-card3)' : 'var(--bg-card3)', color: u.role === 'admin' ? 'var(--success)' : 'var(--accent)' }}>
                      {u.nama.charAt(0).toUpperCase()}
                    </div>
                    <div>
                      <p className="font-semibold text-sm" style={{ color: 'var(--text-primary)' }}>{u.nama}</p>
                      <p className="text-xs" style={{ color: 'var(--text-muted)' }}>{u.email}</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="text-xs px-2 py-0.5 rounded-full"
                          style={{ backgroundColor: u.jalur === 'bintara' ? 'rgba(251,191,36,0.15)' : 'rgba(74,222,128,0.1)', color: u.jalur === 'bintara' ? '#FBBF24' : 'var(--success)', border: '1px solid var(--border)' }}>
                      {u.jalur}
                    </span>
                    {u.izin_latihan_harian && (
                      <span className="text-xs px-2 py-0.5 rounded-full" title="Boleh latihan harian"
                            style={{ backgroundColor: 'rgba(74,222,128,0.12)', color: 'var(--success)', border: '1px solid var(--success)' }}>
                        ✓ latihan
                      </span>
                    )}
                    <span className="text-xs px-2 py-0.5 rounded-full"
                          style={{ backgroundColor: u.role === 'admin' ? 'var(--bg-card3)' : 'var(--bg-card3)', color: u.role === 'admin' ? 'var(--success)' : 'var(--text-muted)', border: '1px solid var(--border)' }}>
                      {u.role}
                    </span>
                    <span style={{ color: 'var(--text-muted)', fontSize: 12 }}>{selected?.id === u.id ? '▲' : '▼'}</span>
                  </div>
                </div>
              </div>

              {/* Panel aksi (muncul saat diklik) */}
              {selected?.id === u.id && (
                <div className="rounded-xl p-4 space-y-3 -mt-1"
                     style={{ backgroundColor: 'var(--bg-card)', border: '1px solid var(--accent)', borderTop: 'none', borderRadius: '0 0 12px 12px' }}>
                  <p className="text-xs font-bold uppercase tracking-wider" style={{ color: 'var(--accent)' }}>
                    Aksi untuk {u.nama}
                  </p>
                  <div className="grid grid-cols-2 gap-2">
                    {/* Lihat Profil Lengkap */}
                    <button onClick={() => setLihatProfilId(u.id)}
                      className="col-span-2 py-2.5 rounded-xl text-xs font-semibold"
                      style={{ backgroundColor: 'var(--bg-card3)', color: 'var(--accent)', border: '1px solid var(--accent)' }}>
                      📊 Lihat Profil Lengkap
                    </button>

                    {/* Ubah Role */}
                    <button onClick={() => handleUbahRole(u.id, u.role)}
                      className="py-2.5 rounded-xl text-xs font-semibold"
                      style={{ backgroundColor: u.role === 'admin' ? 'rgba(220,38,38,0.1)' : 'var(--bg-card3)', color: u.role === 'admin' ? 'var(--danger)' : 'var(--success)', border: '1px solid var(--border)' }}>
                      {u.role === 'admin' ? '⬇️ Jadikan User' : '⬆️ Jadikan Admin'}
                    </button>

                    {/* Ubah Jalur */}
                    <button onClick={() => handleUbahJalur(u.id, u.jalur)}
                      className="py-2.5 rounded-xl text-xs font-semibold"
                      style={{ backgroundColor: 'var(--bg-card3)', color: 'var(--accent)', border: '1px solid var(--border)' }}>
                      🔄 Ganti ke {u.jalur === 'tamtama' ? 'Bintara' : 'Tamtama'}
                    </button>

                    {/* Izin latihan harian */}
                    <label className="col-span-2 flex items-start gap-3 px-3 py-2.5 rounded-xl text-xs cursor-pointer"
                           style={{ backgroundColor: 'var(--bg-card3)', border: `1px solid ${u.izin_latihan_harian ? 'var(--success)' : 'var(--border)'}`, color: 'var(--text-primary)' }}>
                      <input type="checkbox" checked={!!u.izin_latihan_harian}
                        onChange={e => handleIzinLatihan(u.id, e.target.checked)}
                        className="mt-0.5" style={{ accentColor: '#22C55E' }} />
                      <span>
                        <b>Boleh mengerjakan modul latihan harian</b>
                        <span className="block mt-0.5" style={{ color: 'var(--text-muted)' }}>
                          Membuka kunci latihan harian walau tryout aktif belum diselesaikan user ini.
                        </span>
                      </span>
                    </label>

                    {/* Info bergabung */}
                    <div className="col-span-2 px-3 py-2 rounded-xl text-xs"
                         style={{ backgroundColor: 'var(--bg-card2)', color: 'var(--text-muted)' }}>
                      📅 Bergabung: {new Date(u.created_at).toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' })}
                    </div>

                    {/* Hapus Akun */}
                    {u.role !== 'admin' && (
                      <button onClick={() => handleHapus(u.id, u.nama)}
                        className="col-span-2 py-2.5 rounded-xl text-xs font-semibold"
                        style={{ backgroundColor: 'rgba(220,38,38,0.1)', color: 'var(--danger)', border: '1px solid var(--danger)' }}>
                        🗑️ Hapus Akun Ini
                      </button>
                    )}
                    {u.role === 'admin' && (
                      <div className="col-span-2 px-3 py-2 rounded-xl text-xs text-center"
                           style={{ backgroundColor: 'var(--bg-card3)', color: 'var(--text-muted)' }}>
                        ⚠️ Akun admin tidak bisa dihapus dari sini
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ─── Kelola Tryout ────────────────────────────────────────────
// Konversi timestamp dari server (ISO string) ke format yang dipahami input
// datetime-local ("YYYY-MM-DDTHH:mm") — dan sebaliknya tidak perlu, kirim
// apa adanya, backend/Postgres bisa parse string datetime-local langsung.
function keDatetimeLocal(value) {
  if (!value) return '';
  const d = new Date(value);
  if (isNaN(d.getTime())) return '';
  const pad = n => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

// ─── Status Otomatisasi Tryout Mingguan ────────────────────────
// Cron di backend (tiap Senin 00:00 WIB) bikin tryout baru sendiri tanpa
// admin klik apapun — kartu ini kasih visibilitas ke admin: kapan jadwal
// berikutnya, dan apakah run terakhir berhasil/gagal (biar gak "janggal"
// ada proses otomatis yang jalan diam-diam tanpa jejak di panel).
function statusBadgeColor(status) {
  return status === 'sukses'
    ? { bg: '#22c55e22', text: '#22c55e', border: '#22c55e44' }
    : { bg: '#ef444422', text: '#ef4444', border: '#ef444444' };
}

function hitungJadwalBerikutnya() {
  // Hitung "Senin 00:00 WIB berikutnya" berdasarkan waktu sekarang di
  // Asia/Jakarta (bukan zona waktu browser admin, biar akurat kalau admin
  // buka panel dari luar WIB).
  const fmt = new Intl.DateTimeFormat('en-US', {
    timeZone: 'Asia/Jakarta',
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', hour12: false,
  });
  const parts = fmt.formatToParts(new Date());
  const get = (t) => parseInt(parts.find(p => p.type === t).value, 10);
  const y = get('year'), mo = get('month'), d = get('day'), h = get('hour'), mi = get('minute');
  // Dibungkus sebagai UTC supaya angka wall-clock WIB-nya gampang dihitung
  // (WIB tidak ada DST, jadi trik ini aman) — nanti diformat lagi pakai
  // timeZone: 'UTC' supaya angkanya tidak digeser ulang.
  const nowWib = new Date(Date.UTC(y, mo - 1, d, h, mi));
  const hariIni = nowWib.getUTCDay(); // 0=Minggu ... 1=Senin ... 6=Sabtu
  const tambahHari = hariIni === 1 ? 7 : (8 - hariIni) % 7;
  return new Date(Date.UTC(y, mo - 1, d + tambahHari, 0, 0));
}

function StatusOtomatisasiTryout({ token }) {
  const [log, setLog] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showHistori, setShowHistori] = useState(false);

  useEffect(() => {
    apiCall('/api/admin/cron-log?jenis=tryout_mingguan', 'GET', null, token)
      .then(data => { setLog(data.log || []); setLoading(false); })
      .catch(() => setLoading(false));
  }, [token]);

  const jadwalLabel = hitungJadwalBerikutnya().toLocaleDateString('id-ID', {
    weekday: 'long', day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC',
  });

  const terakhir = log[0];
  const badge = terakhir ? statusBadgeColor(terakhir.status) : null;

  return (
    <div className="rounded-xl p-4" style={{ backgroundColor: 'var(--bg-card2)', border: '1px solid var(--border)' }}>
      <div className="flex items-center justify-between mb-3">
        <p className="font-bold text-sm" style={{ color: 'var(--text-primary)' }}>⚙️ Status Otomatisasi Tryout Mingguan</p>
        {log.length > 1 && (
          <button onClick={() => setShowHistori(!showHistori)} className="text-xs font-semibold" style={{ color: 'var(--accent)' }}>
            {showHistori ? 'Sembunyikan histori' : 'Lihat histori'}
          </button>
        )}
      </div>

      <div className="grid grid-cols-2 gap-3">
        <div>
          <p className="text-xs uppercase tracking-wider mb-1" style={{ color: 'var(--text-muted)' }}>Jadwal Berikutnya</p>
          <p className="text-sm font-semibold" style={{ color: 'var(--text-primary)' }}>{jadwalLabel}, 00:00 WIB</p>
        </div>
        <div>
          <p className="text-xs uppercase tracking-wider mb-1" style={{ color: 'var(--text-muted)' }}>Run Terakhir</p>
          {loading ? (
            <p className="text-sm" style={{ color: 'var(--text-muted)' }}>Memuat...</p>
          ) : !terakhir ? (
            <p className="text-sm" style={{ color: 'var(--text-muted)' }}>Belum ada catatan run</p>
          ) : (
            <div className="flex items-center gap-2 flex-wrap">
              <span className="px-2 py-0.5 rounded-full text-xs font-semibold" style={{ backgroundColor: badge.bg, color: badge.text, border: `1px solid ${badge.border}` }}>
                {terakhir.status === 'sukses' ? '✓ Berhasil' : '✗ Gagal'}
              </span>
              <span className="text-xs" style={{ color: 'var(--text-muted)' }}>
                {new Date(terakhir.dijalankan_at).toLocaleString('id-ID', { dateStyle: 'medium', timeStyle: 'short', timeZone: 'Asia/Jakarta' })} WIB
              </span>
            </div>
          )}
        </div>
      </div>

      {terakhir && (
        <p className="text-xs mt-2" style={{ color: 'var(--text-muted)' }}>{terakhir.pesan}</p>
      )}

      {showHistori && log.length > 1 && (
        <div className="mt-3 pt-3 space-y-2" style={{ borderTop: '1px solid var(--border)' }}>
          {log.slice(1).map(item => {
            const b = statusBadgeColor(item.status);
            return (
              <div key={item.id} className="flex items-start justify-between gap-2 text-xs">
                <div className="flex-1">
                  <span className="px-1.5 py-0.5 rounded-full font-semibold mr-2" style={{ backgroundColor: b.bg, color: b.text, border: `1px solid ${b.border}` }}>
                    {item.status === 'sukses' ? '✓' : '✗'}
                  </span>
                  <span style={{ color: 'var(--text-muted)' }}>{item.pesan}</span>
                </div>
                <span style={{ color: 'var(--text-muted)', whiteSpace: 'nowrap' }}>
                  {new Date(item.dijalankan_at).toLocaleDateString('id-ID', { day: 'numeric', month: 'short', timeZone: 'Asia/Jakarta' })}
                </span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

function KelolaTryout({ token }) {
  const [tryouts, setTryouts]   = useState([]);
  const [loading, setLoading]   = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm]         = useState({ judul: '', deskripsi: '', harga: '', tanggal_mulai: '', tanggal_selesai: '' });

  const [editId, setEditId]     = useState(null); // id tryout yang lagi diedit, null = tidak ada
  const [editForm, setEditForm] = useState({ judul: '', deskripsi: '', harga: '', tanggal_mulai: '', tanggal_selesai: '' });
  const [savingEdit, setSavingEdit] = useState(false);

  const loadTryouts = useCallback(() => {
    apiCall('/api/admin/tryouts', 'GET', null, token)
      .then(data => { setTryouts(data.tryouts || []); setLoading(false); })
      .catch(() => setLoading(false));
  }, [token]);

  useEffect(() => { loadTryouts(); }, [loadTryouts]);

  const handleMulaiEdit = (t) => {
    setEditId(t.id);
    setEditForm({
      judul: t.judul || '',
      deskripsi: t.deskripsi || '',
      harga: t.harga || '',
      tanggal_mulai: keDatetimeLocal(t.tanggal_mulai),
      tanggal_selesai: keDatetimeLocal(t.tanggal_selesai),
    });
  };

  const handleSimpanEdit = async () => {
    setSavingEdit(true);
    const data = await apiCall(`/api/admin/tryouts/${editId}`, 'PUT', editForm, token);
    setSavingEdit(false);
    if (data.error) {
      alert(data.error);
    } else {
      setEditId(null);
      loadTryouts();
    }
  };

  const handleBuat = async () => {
    const data = await apiCall('/api/admin/tryouts', 'POST', form, token);
    if (data.tryout) {
      setShowForm(false);
      setForm({ judul: '', deskripsi: '', harga: '', tanggal_mulai: '', tanggal_selesai: '' });
      loadTryouts();
    }
  };

  const handleToggleAktif = async (id, aktif) => {
    await apiCall(`/api/admin/tryouts/${id}`, 'PUT', { aktif: !aktif }, token);
    loadTryouts();
  };

  const handleHapus = async (id, judul) => {
    if (!window.confirm(`Hapus tryout "${judul}"? Tindakan ini tidak bisa dibatalkan.`)) return;
    const data = await apiCall(`/api/admin/tryouts/${id}`, 'DELETE', null, token);
    if (data.error) {
      alert(data.error);
    } else {
      loadTryouts();
    }
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-bold" style={{ color: 'var(--text-primary)', fontFamily: "'Poppins', sans-serif" }}>
          KELOLA TRYOUT
        </h2>
        <button onClick={() => setShowForm(!showForm)}
          className="px-4 py-2 rounded-xl text-sm font-semibold"
          style={{ backgroundColor: 'var(--accent)', color: 'var(--bg-app)' }}>
          + Buat Tryout
        </button>
      </div>

      <StatusOtomatisasiTryout token={token} />

      {/* Form buat tryout */}
      {showForm && (
        <div className="rounded-xl p-5 space-y-3" style={{ backgroundColor: 'var(--bg-card2)', border: '1px solid var(--accent)' }}>
          <p className="font-bold text-sm" style={{ color: 'var(--accent)' }}>Buat Tryout Baru</p>
          {[
            { key: 'judul', label: 'Judul Tryout', type: 'text', placeholder: 'Tryout Periode 1 - Juli 2026' },
            { key: 'deskripsi', label: 'Deskripsi', type: 'text', placeholder: 'Deskripsi singkat tryout' },
            { key: 'harga', label: 'Harga (Rp)', type: 'number', placeholder: '25000' },
            { key: 'tanggal_mulai', label: 'Tanggal Mulai', type: 'datetime-local', placeholder: '' },
            { key: 'tanggal_selesai', label: 'Tanggal Selesai', type: 'datetime-local', placeholder: '' },
          ].map(f => (
            <div key={f.key}>
              <p className="text-xs uppercase tracking-wider mb-1" style={{ color: 'var(--text-muted)' }}>{f.label}</p>
              <input type={f.type} placeholder={f.placeholder}
                value={form[f.key]} onChange={e => setForm(prev => ({ ...prev, [f.key]: e.target.value }))}
                className="w-full px-3 py-2 rounded-lg text-sm focus:outline-none"
                style={{ backgroundColor: 'var(--bg-card)', color: 'var(--text-primary)', border: '1px solid var(--border)' }}
              />
            </div>
          ))}
          <div className="flex gap-3 pt-2">
            <button onClick={handleBuat}
              className="flex-1 py-2.5 rounded-xl font-bold text-sm"
              style={{ backgroundColor: 'var(--accent)', color: 'var(--bg-app)' }}>
              Simpan Tryout
            </button>
            <button onClick={() => setShowForm(false)}
              className="flex-1 py-2.5 rounded-xl text-sm"
              style={{ backgroundColor: 'var(--bg-card3)', color: 'var(--text-muted)', border: '1px solid var(--border)' }}>
              Batal
            </button>
          </div>
        </div>
      )}

      {/* Daftar tryout */}
      {loading ? (
        <p className="text-center py-8" style={{ color: 'var(--text-muted)' }}>Memuat data tryout...</p>
      ) : tryouts.length === 0 ? (
        <div className="text-center py-12 rounded-xl" style={{ backgroundColor: 'var(--bg-card2)', border: '1px solid var(--border)' }}>
          <p className="text-4xl mb-3">🏆</p>
          <p style={{ color: 'var(--text-muted)' }}>Belum ada tryout. Buat tryout pertama!</p>
        </div>
      ) : (
        <div className="space-y-3">
          {tryouts.map(t => (
            <div key={t.id} className="rounded-xl p-4" style={{ backgroundColor: 'var(--bg-card2)', border: `1px solid ${t.aktif ? 'var(--accent)' : 'var(--border)'}` }}>
              <div className="flex items-start justify-between mb-2">
                <div className="flex-1">
                  <p className="font-bold text-sm" style={{ color: 'var(--text-primary)' }}>{t.judul}</p>
                  <p className="text-xs mt-0.5" style={{ color: 'var(--text-muted)' }}>{t.deskripsi}</p>
                  {(t.tanggal_mulai || t.tanggal_selesai) && (
                    <p className="text-xs mt-1" style={{ color: 'var(--text-muted)' }}>
                      🗓️ {t.tanggal_mulai ? new Date(t.tanggal_mulai).toLocaleString('id-ID', { dateStyle: 'medium', timeStyle: 'short' }) : '-'}
                      {' – '}
                      {t.tanggal_selesai ? new Date(t.tanggal_selesai).toLocaleString('id-ID', { dateStyle: 'medium', timeStyle: 'short' }) : '-'}
                    </p>
                  )}
                </div>
                <span className="text-xs px-2 py-1 rounded-full ml-2"
                      style={{ backgroundColor: t.aktif ? 'var(--bg-card3)' : 'var(--bg-card3)', color: t.aktif ? 'var(--success)' : 'var(--text-muted)', border: '1px solid var(--border)' }}>
                  {t.aktif ? '● Aktif' : '○ Nonaktif'}
                </span>
              </div>
              <div className="flex items-center justify-between gap-2">
                <p className="text-sm font-bold" style={{ color: 'var(--accent)' }}>
                  Rp {parseInt(t.harga).toLocaleString('id-ID')}
                </p>
                <div className="flex items-center gap-2">
                  <button onClick={() => (editId === t.id ? setEditId(null) : handleMulaiEdit(t))}
                    className="text-xs px-3 py-1.5 rounded-lg font-semibold"
                    style={{ backgroundColor: 'var(--bg-card3)', color: 'var(--accent)', border: '1px solid var(--border)' }}>
                    ✏️ {editId === t.id ? 'Batal Edit' : 'Edit'}
                  </button>
                  <button onClick={() => handleToggleAktif(t.id, t.aktif)}
                    className="text-xs px-3 py-1.5 rounded-lg font-semibold"
                    style={{ backgroundColor: t.aktif ? 'rgba(220,38,38,0.1)' : 'var(--bg-card3)', color: t.aktif ? 'var(--danger)' : 'var(--success)', border: '1px solid var(--border)' }}>
                    {t.aktif ? 'Nonaktifkan' : 'Aktifkan'}
                  </button>
                  <button onClick={() => handleHapus(t.id, t.judul)}
                    className="text-xs px-3 py-1.5 rounded-lg font-semibold"
                    style={{ backgroundColor: 'var(--bg-card3)', color: 'var(--text-muted)', border: '1px solid var(--border)' }}>
                    🗑️ Hapus
                  </button>
                </div>
              </div>

              {/* Form edit tryout (judul/deskripsi/harga/tanggal) */}
              {editId === t.id && (
                <div className="mt-3 rounded-xl p-4 space-y-3" style={{ backgroundColor: 'var(--bg-card)', border: '1px solid var(--accent)' }}>
                  <p className="font-bold text-sm" style={{ color: 'var(--accent)' }}>Edit Tryout</p>
                  {[
                    { key: 'judul', label: 'Judul Tryout', type: 'text', placeholder: 'Tryout Periode 1 - Juli 2026' },
                    { key: 'deskripsi', label: 'Deskripsi', type: 'text', placeholder: 'Deskripsi singkat tryout' },
                    { key: 'harga', label: 'Harga (Rp)', type: 'number', placeholder: '25000' },
                    { key: 'tanggal_mulai', label: 'Tanggal Mulai', type: 'datetime-local', placeholder: '' },
                    { key: 'tanggal_selesai', label: 'Tanggal Selesai', type: 'datetime-local', placeholder: '' },
                  ].map(f => (
                    <div key={f.key}>
                      <p className="text-xs uppercase tracking-wider mb-1" style={{ color: 'var(--text-muted)' }}>{f.label}</p>
                      <input type={f.type} placeholder={f.placeholder}
                        value={editForm[f.key]} onChange={e => setEditForm(prev => ({ ...prev, [f.key]: e.target.value }))}
                        className="w-full px-3 py-2 rounded-lg text-sm focus:outline-none"
                        style={{ backgroundColor: 'var(--bg-card2)', color: 'var(--text-primary)', border: '1px solid var(--border)' }}
                      />
                    </div>
                  ))}
                  <div className="flex gap-3 pt-2">
                    <button onClick={handleSimpanEdit} disabled={savingEdit}
                      className="flex-1 py-2.5 rounded-xl font-bold text-sm"
                      style={{ backgroundColor: 'var(--accent)', color: 'var(--bg-app)', opacity: savingEdit ? 0.6 : 1 }}>
                      {savingEdit ? 'Menyimpan...' : 'Simpan Perubahan'}
                    </button>
                    <button onClick={() => setEditId(null)}
                      className="flex-1 py-2.5 rounded-xl text-sm"
                      style={{ backgroundColor: 'var(--bg-card3)', color: 'var(--text-muted)', border: '1px solid var(--border)' }}>
                      Batal
                    </button>
                  </div>
                </div>
              )}

              <FormAksesGratis tryoutId={t.id} token={token} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ─── Form kecil: beri akses gratis (lewati pembayaran) ke satu user ───
// Dipakai buat testing/simulasi atau kasus khusus — hanya memberi akses ke
// SATU akun yang dimasukkan emailnya, tidak mengubah harga untuk user lain.
function FormAksesGratis({ tryoutId, token }) {
  const [buka, setBuka]     = useState(false);
  const [email, setEmail]   = useState('');
  const [loading, setLoading] = useState(false);
  const [pesan, setPesan]   = useState(null); // { tipe: 'sukses'|'error', teks }

  const [bukaDaftar, setBukaDaftar]   = useState(false);
  const [daftarGratis, setDaftarGratis] = useState(null); // null = belum dimuat
  const [loadingDaftar, setLoadingDaftar] = useState(false);

  const muatDaftarGratis = async () => {
    if (bukaDaftar) { setBukaDaftar(false); return; }
    setBukaDaftar(true);
    setLoadingDaftar(true);
    const data = await apiCall(`/api/admin/tryouts/${tryoutId}/akses-gratis`, 'GET', null, token);
    setDaftarGratis(data.daftar || []);
    setLoadingDaftar(false);
  };

  const handleKirim = async () => {
    if (!email.trim()) return;
    setLoading(true);
    setPesan(null);
    const data = await apiCall(`/api/admin/tryouts/${tryoutId}/beri-akses`, 'POST', { email: email.trim() }, token);
    setLoading(false);
    if (data.error) {
      setPesan({ tipe: 'error', teks: data.error });
    } else {
      setPesan({ tipe: 'sukses', teks: data.message });
      setEmail('');
      if (bukaDaftar) muatDaftarGratis(); // refresh daftar kalau lagi terbuka
    }
  };

  return (
    <div className="mt-3 pt-3" style={{ borderTop: '1px solid var(--border)' }}>
      <div className="flex items-center gap-2 flex-wrap">
        {!buka && (
          <button onClick={() => setBuka(true)}
            className="text-xs px-3 py-1.5 rounded-lg font-semibold"
            style={{ backgroundColor: 'var(--bg-card3)', color: 'var(--accent)', border: '1px solid var(--border)' }}>
            🎁 Beri Akses Gratis
          </button>
        )}
        <button onClick={muatDaftarGratis}
          className="text-xs px-3 py-1.5 rounded-lg font-semibold"
          style={{ backgroundColor: 'var(--bg-card3)', color: 'var(--text-muted)', border: '1px solid var(--border)' }}>
          📋 {bukaDaftar ? 'Tutup Daftar' : 'Lihat Daftar Akses Gratis'}
        </button>
      </div>

      {buka && (
        <div className="space-y-2 mt-2">
          <p className="text-xs font-semibold" style={{ color: 'var(--text-muted)' }}>
            Beri akses gratis (lewati pembayaran) untuk satu akun — cocok buat testing/simulasi.
          </p>
          <div className="flex gap-2">
            <input type="email" placeholder="email akun tujuan" value={email}
              onChange={e => setEmail(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && handleKirim()}
              className="flex-1 px-3 py-2 rounded-lg text-sm focus:outline-none"
              style={{ backgroundColor: 'var(--bg-card)', color: 'var(--text-primary)', border: '1px solid var(--border)' }}
            />
            <button onClick={handleKirim} disabled={loading || !email.trim()}
              className="px-3 py-2 rounded-lg text-xs font-bold"
              style={{ backgroundColor: 'var(--accent)', color: 'var(--bg-app)', opacity: (loading || !email.trim()) ? 0.5 : 1 }}>
              {loading ? '...' : 'Kirim'}
            </button>
            <button onClick={() => { setBuka(false); setPesan(null); }}
              className="px-3 py-2 rounded-lg text-xs font-semibold"
              style={{ backgroundColor: 'var(--bg-card3)', color: 'var(--text-muted)', border: '1px solid var(--border)' }}>
              Tutup
            </button>
          </div>
          {pesan && (
            <p className="text-xs font-medium" style={{ color: pesan.tipe === 'sukses' ? 'var(--success)' : 'var(--danger)' }}>
              {pesan.tipe === 'sukses' ? '✓ ' : '✗ '}{pesan.teks}
            </p>
          )}
        </div>
      )}

      {bukaDaftar && (
        <div className="mt-2 rounded-lg overflow-hidden" style={{ border: '1px solid var(--border)' }}>
          {loadingDaftar ? (
            <p className="text-xs px-3 py-2" style={{ color: 'var(--text-muted)' }}>Memuat...</p>
          ) : !daftarGratis || daftarGratis.length === 0 ? (
            <p className="text-xs px-3 py-2" style={{ color: 'var(--text-muted)' }}>Belum ada yang diberi akses gratis untuk tryout ini.</p>
          ) : (
            daftarGratis.map((u, i) => (
              <div key={i} className="flex items-center justify-between px-3 py-2 text-xs"
                style={{ backgroundColor: i % 2 === 1 ? 'var(--bg-card3)' : 'transparent', borderTop: i > 0 ? '1px solid var(--border)' : 'none' }}>
                <div>
                  <p className="font-semibold" style={{ color: 'var(--text-primary)' }}>{u.nama}</p>
                  <p style={{ color: 'var(--text-muted)' }}>{u.email}</p>
                </div>
                <p style={{ color: 'var(--text-muted)' }}>
                  {new Date(u.diberikan_at).toLocaleDateString('id-ID', { day: 'numeric', month: 'short', year: 'numeric' })}
                </p>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}

// ─── Label modul (ikon & nama) — SUMBER TUNGGAL, dipakai di Progres Tryout,
// Aktivitas Harian, Log Aktivitas, dll. Tambah modul baru cukup di sini saja.
const MODUL_LABEL = {
  kraepelin:   { nama: 'Kraepelin/Pauli',   icon: '🧮' },
  kecermatan:  { nama: 'Kecermatan',        icon: '✅' },
  logika:      { nama: 'Logika & Numerik',  icon: '🔢' },
  verbal:      { nama: 'Verbal',            icon: '📖' },
  figural:     { nama: 'Figural & Spasial', icon: '🧩' },
  kepribadian: { nama: 'Kepribadian',       icon: '🧠' },
  akademik:    { nama: 'Kemampuan Akademik',icon: '📚' },
  armyalpha:   { nama: 'Instruksi Cepat',   icon: '⚡' },
  mekanik:     { nama: 'Bakat Mekanik',     icon: '⚙️' },
  substitusi:  { nama: 'Substitusi Simbol', icon: '🔣' },
  kestabilan:  { nama: 'Kestabilan Pribadi', icon: '🛡️' },
  interpretasigambar: { nama: 'Interpretasi Gambar', icon: '🖼️' },
  interpretasibentuk: { nama: 'Interpretasi Bentuk', icon: '🔮' },
};

// ─── Progres Tryout (log harian: siapa sudah selesai modul apa) ───
// PENTING: roster modul tryout itu BEDA-BEDA tergantung tanggal_mulai tryout
// yang sedang dilihat (lihat modulBaruConfig.js) — modul baru (Interpretasi
// Gambar/Bentuk) baru resmi masuk Tryout mulai 31 Agustus 2026. Kalau dipukul
// rata pakai daftar 13 modul (Object.keys(MODUL_LABEL)) untuk SEMUA tryout,
// maka untuk tryout minggu-minggu sebelum 31 Agustus (yang cuma 11 modul)
// jumlahModulSelesai user tidak akan pernah sama dengan panjang roster, dan
// tombol "Finalisasi & Unduh PDF" jadi tidak pernah muncul walau user itu
// sudah benar-benar menyelesaikan semua modul yang berlaku buat tryout-nya.
// Makanya rosternya dihitung dinamis di dalam komponen ProgresTryout di bawah,
// bukan statis di sini. MODUL_LABEL sendiri tetap dipakai apa adanya cuma
// untuk lookup nama/ikon tampilan.
function urutanModulUntukTryout(tryout) {
  return modulBaruAktif(tryout?.tanggal_mulai) ? [...MODUL_DASAR, ...MODUL_BARU_IDS] : MODUL_DASAR;
}

function ProgresTryout({ token }) {
  const [tryouts, setTryouts] = useState([]);
  const [tryoutId, setTryoutId] = useState(null);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [finalisasi, setFinalisasi] = useState({}); // userId -> 'loading' | 'error'

  useEffect(() => {
    apiCall('/api/admin/tryouts', 'GET', null, token).then(d => {
      const list = d.tryouts || [];
      setTryouts(list);
      // Default: tryout aktif kalau ada, kalau tidak yang paling baru dibuat
      const aktifDulu = list.find(t => t.aktif) || list[0];
      if (aktifDulu) setTryoutId(aktifDulu.id);
      else setLoading(false);
    }).catch(() => setLoading(false));
  }, [token]);

  const muatProgres = useCallback(() => {
    if (!tryoutId) return;
    apiCall(`/api/admin/tryouts/${tryoutId}/progres`, 'GET', null, token)
      .then(d => { setData(d); setLoading(false); })
      .catch(() => setLoading(false));
  }, [tryoutId, token]);

  useEffect(() => {
    setLoading(true);
    muatProgres();
    const interval = setInterval(muatProgres, 15000); // auto-refresh tiap 15 detik, log "harian" real-time
    return () => clearInterval(interval);
  }, [muatProgres]);

  // Untuk user yang sudah selesai semua modul tapi tidak sempat menekan "Kirim
  // Hasil Tryout" sendiri (mis. keluar aplikasi setelah modul terakhir) — admin
  // bisa finalisasi manual di sini, lalu langsung unduh PDF hasilnya.
  const handleFinalisasi = async (p) => {
    setFinalisasi(f => ({ ...f, [p.userId]: 'loading' }));
    try {
      await apiCall(`/api/admin/tryouts/${tryoutId}/users/${p.userId}/finalisasi`, 'POST', null, token);
      await unduhPdf(`${API_URL}/api/admin/laporan/tryout/${p.userId}/${tryoutId}`, token, `laporan-tryout-${p.nama}.pdf`);
      setFinalisasi(f => { const next = { ...f }; delete next[p.userId]; return next; });
      muatProgres();
    } catch (err) {
      setFinalisasi(f => ({ ...f, [p.userId]: err.message || 'error' }));
    }
  };

  // Roster modul yang berlaku buat tryout yang lagi dilihat — bukan daftar statis,
  // supaya cocok baik untuk tryout lama (11 modul) maupun tryout baru mulai 31
  // Agustus 2026 (13 modul, lihat modulBaruConfig.js & urutanModulUntukTryout di atas).
  const urutanModulTryoutIni = urutanModulUntukTryout(data?.tryout);

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <h2 className="text-xl font-bold" style={{ color: 'var(--text-primary)', fontFamily: "'Poppins', sans-serif" }}>
          PROGRES TRYOUT
        </h2>
        {tryouts.length > 0 && (
          <select value={tryoutId || ''} onChange={e => setTryoutId(e.target.value)}
            className="px-3 py-2 rounded-lg text-sm focus:outline-none"
            style={{ backgroundColor: 'var(--bg-card2)', color: 'var(--text-primary)', border: '1px solid var(--border)' }}>
            {tryouts.map(t => (
              <option key={t.id} value={t.id}>{t.judul}{t.aktif ? ' (aktif)' : ''}</option>
            ))}
          </select>
        )}
      </div>

      {loading ? (
        <p className="text-center py-8" style={{ color: 'var(--text-muted)' }}>Memuat progres...</p>
      ) : !data || tryouts.length === 0 ? (
        <div className="text-center py-12 rounded-xl" style={{ backgroundColor: 'var(--bg-card2)', border: '1px solid var(--border)' }}>
          <p className="text-4xl mb-3">📋</p>
          <p style={{ color: 'var(--text-muted)' }}>Belum ada tryout untuk dipantau.</p>
        </div>
      ) : data.peserta.length === 0 ? (
        <div className="text-center py-12 rounded-xl" style={{ backgroundColor: 'var(--bg-card2)', border: '1px solid var(--border)' }}>
          <p className="text-4xl mb-3">💤</p>
          <p style={{ color: 'var(--text-muted)' }}>Belum ada peserta yang mulai mengerjakan "{data.tryout.judul}".</p>
        </div>
      ) : (
        <div className="space-y-3">
          <p className="text-xs" style={{ color: 'var(--text-muted)' }}>
            {data.peserta.length} peserta tercatat · auto-refresh tiap 15 detik
          </p>
          {data.peserta.map(p => (
            <div key={p.userId} className="rounded-xl p-4"
              style={{ backgroundColor: 'var(--bg-card2)', border: `1px solid ${p.sudahSubmit ? 'var(--success)' : 'var(--border)'}` }}>
              <div className="flex items-start justify-between mb-3">
                <div>
                  <p className="font-semibold text-sm" style={{ color: 'var(--text-primary)' }}>{p.nama}</p>
                  <p className="text-xs" style={{ color: 'var(--text-muted)' }}>{p.email}</p>
                </div>
                <div className="text-right">
                  {p.sudahSubmit ? (
                    <>
                      <span className="text-xs px-2 py-1 rounded-full font-bold"
                        style={{ backgroundColor: 'rgba(74,222,128,0.15)', color: 'var(--success)' }}>
                        ✓ Selesai — {p.skorAkumulasi}
                      </span>
                      <p className="text-[10px] mt-1" style={{ color: 'var(--text-muted)' }}>{formatTgl(p.selesaiSubmitAt)}</p>
                    </>
                  ) : (
                    <>
                      <span className="text-xs px-2 py-1 rounded-full font-bold"
                        style={{ backgroundColor: 'var(--bg-card3)', color: 'var(--accent)' }}>
                        {p.jumlahModulSelesai}/{urutanModulTryoutIni.length} modul
                      </span>
                      <p className="text-[10px] mt-1" style={{ color: 'var(--text-muted)' }}>terakhir {formatTgl(p.terakhirAktif)}</p>
                    </>
                  )}
                </div>
              </div>
              <div className="grid gap-1.5" style={{ gridTemplateColumns: `repeat(${urutanModulTryoutIni.length}, minmax(0, 1fr))` }}>
                {urutanModulTryoutIni.map(m => {
                  const selesai = p.modul[m];
                  return (
                    <div key={m} title={`${MODUL_LABEL[m]?.nama || m}${selesai ? ` — skor ${selesai.skor}` : ' — belum dikerjakan'}`}
                      className="rounded-lg py-2 flex flex-col items-center gap-0.5"
                      style={{ backgroundColor: selesai ? 'rgba(74,222,128,0.12)' : 'var(--bg-card3)', border: `1px solid ${selesai ? 'var(--success)' : 'var(--border)'}` }}>
                      <span className="text-sm">{MODUL_LABEL[m]?.icon || '📝'}</span>
                      <span className="text-[9px] font-bold font-mono" style={{ color: selesai ? 'var(--success)' : 'var(--text-faint)' }}>
                        {selesai ? selesai.skor : '—'}
                      </span>
                    </div>
                  );
                })}
              </div>
              {!p.sudahSubmit && p.jumlahModulSelesai === urutanModulTryoutIni.length && (
                <div className="mt-3 pt-3" style={{ borderTop: '1px solid var(--border)' }}>
                  <p className="text-[10px] mb-2" style={{ color: 'var(--text-muted)' }}>
                    Semua modul sudah dikerjakan tapi belum ditekan "Kirim Hasil Tryout" oleh user ini.
                  </p>
                  <button onClick={() => handleFinalisasi(p)} disabled={finalisasi[p.userId] === 'loading'}
                    className="text-xs px-3 py-1.5 rounded-lg font-semibold"
                    style={{ backgroundColor: 'var(--accent)', color: '#1B2017' }}>
                    {finalisasi[p.userId] === 'loading' ? 'Memproses...' : 'Finalisasi & Unduh PDF'}
                  </button>
                  {finalisasi[p.userId] && finalisasi[p.userId] !== 'loading' && (
                    <p className="text-[10px] mt-1" style={{ color: 'var(--danger)' }}>{finalisasi[p.userId]}</p>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ─── Peringkat (leaderboard total XP) ──────────────────────────
// Sebelumnya ini tab "Peringkat" yang tampil ke semua user biasa di app
// (RiwayatScreen). Sekarang dihapus dari sana dan cuma bisa dilihat admin
// di sini — datanya sama persis (dari /api/leaderboard), cuma sisi admin
// pakai endpoint terpisah /api/admin/leaderboard (auth admin, bukan token
// user, dan tidak butuh "posisi saya" karena admin bukan peserta).
const MEDALI_ADMIN = ['🥇', '🥈', '🥉'];

function PeringkatAdmin({ token }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    apiCall('/api/admin/leaderboard', 'GET', null, token)
      .then(d => { setData(d); setLoading(false); })
      .catch(() => setLoading(false));
  }, [token]);

  const leaderboard = data?.leaderboard || [];

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-bold" style={{ color: 'var(--text-primary)', fontFamily: "'Poppins', sans-serif" }}>
        PERINGKAT
      </h2>
      <p className="text-xs" style={{ color: 'var(--text-muted)' }}>
        🏆 Peringkat berdasarkan total XP dari seluruh latihan &amp; tryout (top 50)
      </p>

      {loading ? (
        <p className="text-center py-8" style={{ color: 'var(--text-muted)' }}>Memuat peringkat...</p>
      ) : leaderboard.length === 0 ? (
        <div className="text-center py-12 rounded-xl" style={{ backgroundColor: 'var(--bg-card2)', border: '1px solid var(--border)' }}>
          <p className="text-4xl mb-3">🏆</p>
          <p style={{ color: 'var(--text-muted)' }}>Belum ada peringkat.</p>
        </div>
      ) : (
        <div className="space-y-1.5">
          {leaderboard.map(u => (
            <div key={u.userId} className="rounded-xl p-3 flex items-center gap-3"
                 style={{ backgroundColor: 'var(--bg-card2)', border: '1px solid var(--border)' }}>
              <div className="w-8 text-center shrink-0">
                {u.rank <= 3 ? (
                  <span className="text-lg">{MEDALI_ADMIN[u.rank - 1]}</span>
                ) : (
                  <span className="text-xs font-bold font-mono" style={{ color: 'var(--text-muted)' }}>#{u.rank}</span>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-semibold text-sm truncate" style={{ color: 'var(--text-primary)' }}>{u.nama}</p>
                <p className="text-[11px]" style={{ color: 'var(--text-muted)' }}>Level {u.level} · {u.jumlahSesi} sesi</p>
              </div>
              <p className="text-sm font-bold font-mono shrink-0" style={{ color: 'var(--accent)' }}>{u.xp} XP</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function formatTgl(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  return `${d.getDate()} ${['Jan','Feb','Mar','Apr','Mei','Jun','Jul','Agu','Sep','Okt','Nov','Des'][d.getMonth()]} ${d.getFullYear()} · ${d.getHours().toString().padStart(2,'0')}:${d.getMinutes().toString().padStart(2,'0')}`;
}

// ─── Aktivitas Harian (konsistensi & skor latihan per user) ───
// Sparkline SVG kecil buat nunjukin tren skor satu modul (tanpa perlu library chart)
function Sparkline({ data }) {
  if (data.length < 2) return null;
  const W = 180, H = 40, PAD = 4;
  const maks = Math.max(100, ...data.map(d => d.skor));
  const points = data.map((d, i) => {
    const x = PAD + (i / (data.length - 1)) * (W - PAD * 2);
    const y = H - PAD - (d.skor / maks) * (H - PAD * 2);
    return `${x.toFixed(1)},${y.toFixed(1)}`;
  }).join(' ');
  const naik = data[data.length - 1].skor >= data[0].skor;
  return (
    <svg viewBox={`0 0 ${W} ${H}`} style={{ width: 100, height: 28 }}>
      <polyline points={points} fill="none" stroke={naik ? 'var(--success)' : 'var(--danger)'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function AktivitasHarian({ token }) {
  const [ringkasan, setRingkasan] = useState([]);
  const [loading, setLoading]     = useState(true);
  const [detailUser, setDetailUser] = useState(null); // userId yang lagi dibuka detailnya
  const [detailSesi, setDetailSesi] = useState([]);
  const [perkembangan, setPerkembangan] = useState(null);
  const [loadingDetail, setLoadingDetail] = useState(false);
  const [loadingPdfUser, setLoadingPdfUser] = useState(null);

  useEffect(() => {
    apiCall('/api/admin/aktivitas-harian', 'GET', null, token)
      .then(data => { setRingkasan(data.ringkasan || []); setLoading(false); })
      .catch(() => setLoading(false));
  }, [token]);

  const handleUnduhPdfHarian = async (u) => {
    setLoadingPdfUser(u.userId);
    try {
      await unduhPdf(`${API_URL}/api/admin/laporan/harian/${u.userId}`, token, `laporan-latihan-${u.nama}.pdf`);
    } catch (err) {
      alert(err.message || 'Gagal mengunduh laporan.');
    }
    setLoadingPdfUser(null);
  };

  const bukaDetail = async (userId) => {
    if (detailUser === userId) { setDetailUser(null); return; }
    setDetailUser(userId);
    setLoadingDetail(true);
    const [dataSesi, dataPerkembangan] = await Promise.all([
      apiCall(`/api/admin/users/${userId}/sesi-latihan`, 'GET', null, token),
      apiCall(`/api/admin/users/${userId}/perkembangan`, 'GET', null, token),
    ]);
    setDetailSesi(dataSesi.sesi || []);
    setPerkembangan(dataPerkembangan);
    setLoadingDetail(false);
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-bold" style={{ color: 'var(--text-primary)', fontFamily: "'Poppins', sans-serif" }}>
          AKTIVITAS LATIHAN HARIAN
        </h2>
        <span className="text-sm px-3 py-1 rounded-full" style={{ backgroundColor: 'var(--bg-card3)', color: 'var(--accent)' }}>
          {ringkasan.length} user aktif
        </span>
      </div>

      {loading ? (
        <p className="text-center py-8" style={{ color: 'var(--text-muted)' }}>Memuat data aktivitas...</p>
      ) : ringkasan.length === 0 ? (
        <div className="text-center py-12 rounded-xl" style={{ backgroundColor: 'var(--bg-card2)', border: '1px solid var(--border)' }}>
          <p className="text-4xl mb-3">📊</p>
          <p style={{ color: 'var(--text-muted)' }}>Belum ada user yang latihan.</p>
        </div>
      ) : (
        <div className="space-y-2">
          {ringkasan.map(u => (
            <div key={u.userId}>
              <div onClick={() => bukaDetail(u.userId)}
                className="rounded-xl p-4 cursor-pointer transition"
                style={{
                  backgroundColor: detailUser === u.userId ? 'var(--bg-card3)' : 'var(--bg-card2)',
                  border: `1px solid ${detailUser === u.userId ? 'var(--accent)' : 'var(--border)'}`
                }}>
                <div className="flex items-center justify-between">
                  <div>
                    <p className="font-semibold text-sm" style={{ color: 'var(--text-primary)' }}>{u.nama}</p>
                    <p className="text-xs" style={{ color: 'var(--text-muted)' }}>{u.email}</p>
                  </div>
                  <div className="flex items-center gap-4 text-right">
                    <div>
                      <p className="text-[10px] uppercase" style={{ color: 'var(--text-muted)' }}>Sesi</p>
                      <p className="font-bold font-mono text-sm" style={{ color: 'var(--text-primary)' }}>{u.totalSesi}</p>
                    </div>
                    <div>
                      <p className="text-[10px] uppercase" style={{ color: 'var(--text-muted)' }}>Rata-rata</p>
                      <p className="font-bold font-mono text-sm" style={{ color: 'var(--accent)' }}>{u.rataRata}</p>
                    </div>
                    <div>
                      <p className="text-[10px] uppercase" style={{ color: 'var(--text-muted)' }}>Streak</p>
                      <p className="font-bold font-mono text-sm" style={{ color: u.streak > 0 ? '#FBBF24' : 'var(--text-muted)' }}>
                        {u.streak > 0 ? `${u.streak}🔥` : '—'}
                      </p>
                    </div>
                  </div>
                </div>
                <p className="text-[11px] mt-2" style={{ color: 'var(--text-muted)' }}>
                  Terakhir: {MODUL_LABEL[u.modulTerakhir]?.icon || '📝'} {MODUL_LABEL[u.modulTerakhir]?.nama || u.modulTerakhir} · {formatTgl(u.tanggalTerakhir)}
                </p>
              </div>

              {detailUser === u.userId && (
                <div className="rounded-xl p-4 space-y-3 -mt-1" style={{ backgroundColor: 'var(--bg-card)', border: '1px solid var(--accent)', borderTop: 'none', borderRadius: '0 0 12px 12px' }}>
                  {loadingDetail ? (
                    <p className="text-xs" style={{ color: 'var(--text-muted)' }}>Memuat...</p>
                  ) : (
                    <>
                      <div className="flex items-center justify-between">
                        <p className="text-xs font-bold uppercase tracking-wider" style={{ color: 'var(--accent)' }}>
                          Perkembangan {u.nama}
                        </p>
                        <button onClick={() => handleUnduhPdfHarian(u)} disabled={loadingPdfUser === u.userId}
                          className="text-[10px] font-semibold px-2.5 py-1 rounded-lg"
                          style={{ backgroundColor: 'var(--bg-card2)', border: '1px solid var(--accent)', color: 'var(--accent)' }}>
                          {loadingPdfUser === u.userId ? 'Menyiapkan...' : '⬇ Unduh PDF'}
                        </button>
                      </div>

                      {/* Kartu ringkasan */}
                      <div className="grid grid-cols-3 gap-2">
                        <div className="rounded-lg p-2 text-center" style={{ backgroundColor: 'var(--bg-card2)' }}>
                          <p className="text-[9px] uppercase" style={{ color: 'var(--text-muted)' }}>Rata-rata</p>
                          <p className="text-sm font-bold font-mono" style={{ color: 'var(--text-primary)' }}>{perkembangan?.ringkasan?.rataRata ?? '—'}</p>
                        </div>
                        <div className="rounded-lg p-2 text-center" style={{ backgroundColor: 'var(--bg-card2)' }}>
                          <p className="text-[9px] uppercase" style={{ color: 'var(--text-muted)' }}>Tren 14 hari</p>
                          <p className="text-sm font-bold font-mono" style={{ color: perkembangan?.ringkasan?.tren14Hari > 0 ? 'var(--success)' : perkembangan?.ringkasan?.tren14Hari < 0 ? 'var(--danger)' : 'var(--text-muted)' }}>
                            {perkembangan?.ringkasan?.tren14Hari == null ? '—' : perkembangan.ringkasan.tren14Hari > 0 ? `▲ +${perkembangan.ringkasan.tren14Hari}` : perkembangan.ringkasan.tren14Hari < 0 ? `▼ ${perkembangan.ringkasan.tren14Hari}` : '● 0'}
                          </p>
                        </div>
                        <div className="rounded-lg p-2 text-center" style={{ backgroundColor: 'var(--bg-card2)' }}>
                          <p className="text-[9px] uppercase" style={{ color: 'var(--text-muted)' }}>Streak</p>
                          <p className="text-sm font-bold font-mono" style={{ color: 'var(--text-primary)' }}>{perkembangan?.ringkasan?.streak > 0 ? `${perkembangan.ringkasan.streak}🔥` : '—'}</p>
                        </div>
                      </div>

                      {/* Kartu peringatan "perlu perhatian" */}
                      {perkembangan?.peringatan?.length > 0 && (
                        <div className="rounded-lg p-3" style={{ backgroundColor: 'rgba(220,38,38,0.08)', border: '1px solid rgba(220,38,38,0.25)' }}>
                          <p className="text-[11px] font-bold mb-1" style={{ color: 'var(--danger)' }}>⚠️ Perlu perhatian</p>
                          {perkembangan.peringatan.map((p, i) => (
                            <p key={i} className="text-[11px] leading-relaxed" style={{ color: 'var(--text-muted)' }}>• {p}</p>
                          ))}
                        </div>
                      )}

                      {/* Sparkline tren per modul */}
                      {perkembangan?.perModul && Object.keys(perkembangan.perModul).length > 0 && (
                        <div className="space-y-1.5">
                          {Object.entries(perkembangan.perModul).map(([modulId, data]) => (
                            <div key={modulId} className="flex items-center justify-between px-3 py-2 rounded-lg" style={{ backgroundColor: 'var(--bg-card2)' }}>
                              <span className="text-xs" style={{ color: 'var(--text-primary)' }}>
                                {MODUL_LABEL[modulId]?.icon || '📝'} {MODUL_LABEL[modulId]?.nama || modulId}
                              </span>
                              <div className="flex items-center gap-2">
                                <Sparkline data={data} />
                                <span className="text-xs font-bold font-mono" style={{ color: 'var(--accent)' }}>{data[data.length - 1].skor}</span>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}

                      {/* Riwayat lengkap (raw) */}
                      <details>
                        <summary className="text-[11px] cursor-pointer" style={{ color: 'var(--text-muted)' }}>Lihat semua riwayat sesi ({detailSesi.length})</summary>
                        <div className="space-y-1.5 mt-2">
                          {detailSesi.map(s => (
                            <div key={s.id} className="flex items-center justify-between text-xs px-3 py-2 rounded-lg" style={{ backgroundColor: 'var(--bg-card2)' }}>
                              <span style={{ color: 'var(--text-primary)' }}>
                                {MODUL_LABEL[s.modul_id]?.icon || '📝'} {MODUL_LABEL[s.modul_id]?.nama || s.modul_id}
                              </span>
                              <span style={{ color: 'var(--text-muted)' }}>{formatTgl(s.dikerjakan_at)}</span>
                              <span className="font-bold font-mono" style={{ color: 'var(--accent)' }}>{s.skor}</span>
                            </div>
                          ))}
                        </div>
                      </details>
                    </>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ─── Hasil Tryout Resmi (semua user) ───────────────────────────
function HasilTryoutAdmin({ token }) {
  const [hasil, setHasil]     = useState([]);
  const [loading, setLoading] = useState(true);
  const [idPdfLoading, setIdPdfLoading] = useState(null);
  const [terpilih, setTerpilih] = useState([]); // id hasil_tryout yang dicentang
  const [belumKirim, setBelumKirim] = useState([]); // sudah mengerjakan modul tapi belum menekan Kirim Hasil
  const [terpilihBelum, setTerpilihBelum] = useState([]); // kunci 'userId:tryoutId'
  const kunciBelum = (b) => `${b.user_id}:${b.tryout_id}`;
  const toggleBelum = (k) => setTerpilihBelum(t => t.includes(k) ? t.filter(x => x !== k) : [...t, k]);
  const [loadingGabungan, setLoadingGabungan] = useState(false);

  const toggleTerpilih = (id) => setTerpilih(t => t.includes(id) ? t.filter(x => x !== id) : [...t, id]);

  const handleUnduhGabungan = async () => {
    setLoadingGabungan(true);
    try {
      await unduhPdf(`${API_URL}/api/admin/laporan/gabungan`, token, 'laporan-gabungan-tryout.pdf', { method: 'POST', body: { hasil_ids: terpilih, belum_kirim: belumKirim.filter(b => terpilihBelum.includes(kunciBelum(b))).map(b => ({ user_id: b.user_id, tryout_id: b.tryout_id })) } });
    } catch (err) {
      alert(err.message || 'Gagal membuat laporan gabungan.');
    }
    setLoadingGabungan(false);
  };

  useEffect(() => {
    apiCall('/api/admin/hasil-tryout', 'GET', null, token)
      .then(data => { setHasil(data.hasil || []); setBelumKirim(data.belumKirim || []); setLoading(false); })
      .catch(() => setLoading(false));
  }, [token]);

  const handleUnduhPdf = async (h) => {
    setIdPdfLoading(h.id);
    try {
      await unduhPdf(`${API_URL}/api/admin/laporan/tryout/${h.user_id}/${h.tryout_id}`, token, `laporan-tryout-${h.nama}.pdf`);
    } catch (err) {
      alert(err.message || 'Gagal mengunduh laporan.');
    }
    setIdPdfLoading(null);
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-bold" style={{ color: 'var(--text-primary)', fontFamily: "'Poppins', sans-serif" }}>
          HASIL TRYOUT
        </h2>
        <span className="text-sm px-3 py-1 rounded-full" style={{ backgroundColor: 'var(--bg-card3)', color: 'var(--accent)' }}>
          {hasil.length} hasil
        </span>
      </div>

      {(hasil.length > 0 || belumKirim.length > 0) && (
        <div className="flex items-center gap-2 flex-wrap sticky top-0 z-10 py-2" style={{ backgroundColor: 'var(--bg-app)' }}>
          <button onClick={() => {
              const semua = terpilih.length === hasil.length && terpilihBelum.length === belumKirim.length;
              setTerpilih(semua ? [] : hasil.map(h => h.id));
              setTerpilihBelum(semua ? [] : belumKirim.map(kunciBelum));
            }}
            className="text-xs font-semibold px-3 py-1.5 rounded-lg"
            style={{ backgroundColor: 'var(--bg-card3)', border: '1px solid var(--border)', color: 'var(--text-primary)' }}>
            {terpilih.length === hasil.length && terpilihBelum.length === belumKirim.length ? 'Batal pilih semua' : 'Pilih semua'}
          </button>
          <button onClick={handleUnduhGabungan} disabled={terpilih.length + terpilihBelum.length === 0 || loadingGabungan}
            className="text-xs font-semibold px-3 py-1.5 rounded-lg"
            style={{ backgroundColor: (terpilih.length + terpilihBelum.length) ? 'var(--accent)' : 'var(--bg-card3)', color: (terpilih.length + terpilihBelum.length) ? '#1B2017' : 'var(--text-muted)', opacity: loadingGabungan ? 0.7 : 1 }}>
            {loadingGabungan ? 'Menyiapkan...' : `⬇ Laporan Gabungan (${terpilih.length + terpilihBelum.length} dipilih)`}
          </button>
        </div>
      )}

      {loading ? (
        <p className="text-center py-8" style={{ color: 'var(--text-muted)' }}>Memuat hasil tryout...</p>
      ) : hasil.length === 0 && belumKirim.length === 0 ? (
        <div className="text-center py-12 rounded-xl" style={{ backgroundColor: 'var(--bg-card2)', border: '1px solid var(--border)' }}>
          <p className="text-4xl mb-3">🏆</p>
          <p style={{ color: 'var(--text-muted)' }}>Belum ada user yang mengerjakan tryout.</p>
        </div>
      ) : (
        <div className="space-y-3">
          {hasil.map(h => (
            <div key={h.id} className="rounded-xl p-4" style={{ backgroundColor: 'var(--bg-card2)', border: '1px solid var(--border)' }}>
              <div className="flex items-center justify-between mb-1">
                <div className="flex items-center gap-3">
                  <input type="checkbox" checked={terpilih.includes(h.id)} onChange={() => toggleTerpilih(h.id)}
                    style={{ accentColor: '#22C55E', width: 18, height: 18 }} />
                  <div>
                    <p className="font-semibold text-sm" style={{ color: 'var(--text-primary)' }}>{h.nama}</p>
                    <p className="text-xs" style={{ color: 'var(--text-muted)' }}>{h.email}</p>
                  </div>
                </div>
                <div className="text-right">
                  <p className="text-xl font-bold font-mono" style={{ color: 'var(--accent)' }}>{h.skor_akumulasi}</p>
                  <p className="text-[10px]" style={{ color: 'var(--text-muted)' }}>skor akumulasi</p>
                </div>
              </div>
              <p className="text-xs mb-2" style={{ color: 'var(--text-muted)' }}>
                {h.tryout_judul || `Tryout #${h.tryout_id}`} · {formatTgl(h.selesai_at)}
              </p>
              <button onClick={() => handleUnduhPdf(h)} disabled={idPdfLoading === h.id}
                className="text-xs font-semibold px-3 py-1.5 rounded-lg"
                style={{ backgroundColor: 'var(--bg-card3)', border: '1px solid var(--accent)', color: 'var(--accent)' }}>
                {idPdfLoading === h.id ? 'Menyiapkan...' : '⬇ Unduh PDF'}
              </button>
            </div>
          ))}
        </div>
      )}

      {belumKirim.length > 0 && (
        <div className="space-y-3 pt-2">
          <div>
            <p className="text-sm font-bold" style={{ color: 'var(--warning)' }}>Belum menekan "Kirim Hasil" ({belumKirim.length})</p>
            <p className="text-xs" style={{ color: 'var(--text-muted)' }}>
              Sudah mengerjakan modul tapi belum tercatat sebagai hasil resmi. Tetap bisa dicentang untuk laporan gabungan (skor dihitung sementara dari modul yang sudah selesai, ditandai * di PDF).
            </p>
          </div>
          {belumKirim.map(b => (
            <div key={kunciBelum(b)} className="rounded-xl p-4" style={{ backgroundColor: 'var(--bg-card2)', border: '1px dashed var(--warning)' }}>
              <div className="flex items-center justify-between mb-1">
                <div className="flex items-center gap-3">
                  <input type="checkbox" checked={terpilihBelum.includes(kunciBelum(b))} onChange={() => toggleBelum(kunciBelum(b))}
                    style={{ accentColor: '#22C55E', width: 18, height: 18 }} />
                  <div>
                    <p className="font-semibold text-sm" style={{ color: 'var(--text-primary)' }}>{b.nama}</p>
                    <p className="text-xs" style={{ color: 'var(--text-muted)' }}>{b.email}</p>
                  </div>
                </div>
                <div className="text-right">
                  <p className="text-xl font-bold font-mono" style={{ color: 'var(--accent)' }}>{b.skor_akumulasi}</p>
                  <p className="text-[10px]" style={{ color: 'var(--text-muted)' }}>{b.jumlah_modul} modul dikerjakan</p>
                </div>
              </div>
              <p className="text-xs" style={{ color: 'var(--text-muted)' }}>
                {b.tryout_judul || `Tryout #${b.tryout_id}`} · terakhir {formatTgl(b.selesai_at)}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ─── Pembayaran Tryout (siapa sudah/belum bayar) ───────────────
function formatRupiahAdmin(n) {
  return 'Rp' + Number(n || 0).toLocaleString('id-ID');
}

const STATUS_BAYAR_WARNA = {
  success: { bg: 'rgba(74,222,128,0.15)', text: 'var(--success)', label: '✓ Lunas' },
  pending: { bg: 'rgba(250,204,21,0.15)', text: '#facc15', label: '⏳ Menunggu' },
  failed:  { bg: 'rgba(248,113,113,0.15)', text: '#f87171', label: '✕ Gagal' },
};

function PembayaranAdmin({ token }) {
  const [pembayaran, setPembayaran] = useState([]);
  const [loading, setLoading]       = useState(true);
  const [filter, setFilter]         = useState('semua');

  useEffect(() => {
    apiCall('/api/admin/pembayaran', 'GET', null, token)
      .then(data => { setPembayaran(data.pembayaran || []); setLoading(false); })
      .catch(() => setLoading(false));
  }, [token]);

  const terfilter = filter === 'semua' ? pembayaran : pembayaran.filter(p => p.status === filter);
  const totalLunas = pembayaran.filter(p => p.status === 'success').reduce((a, p) => a + Number(p.jumlah), 0);

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <h2 className="text-xl font-bold" style={{ color: 'var(--text-primary)', fontFamily: "'Poppins', sans-serif" }}>
          PEMBAYARAN
        </h2>
        <span className="text-sm px-3 py-1 rounded-full" style={{ backgroundColor: 'var(--bg-card3)', color: 'var(--accent)' }}>
          Total lunas: {formatRupiahAdmin(totalLunas)}
        </span>
      </div>

      <div className="flex gap-2 flex-wrap">
        {[
          { id: 'semua', label: 'Semua' },
          { id: 'success', label: '✓ Lunas' },
          { id: 'pending', label: '⏳ Menunggu' },
          { id: 'failed', label: '✕ Gagal' },
        ].map(f => (
          <button key={f.id} onClick={() => setFilter(f.id)}
            className="px-3 py-1.5 rounded-lg text-xs font-semibold transition"
            style={{
              backgroundColor: filter === f.id ? 'var(--accent)' : 'var(--bg-card2)',
              color: filter === f.id ? '#fff' : 'var(--text-muted)',
              border: '1px solid var(--border)',
            }}>
            {f.label}
          </button>
        ))}
      </div>

      {loading ? (
        <p className="text-center py-8" style={{ color: 'var(--text-muted)' }}>Memuat data pembayaran...</p>
      ) : terfilter.length === 0 ? (
        <div className="text-center py-12 rounded-xl" style={{ backgroundColor: 'var(--bg-card2)', border: '1px solid var(--border)' }}>
          <p className="text-4xl mb-3">💳</p>
          <p style={{ color: 'var(--text-muted)' }}>Belum ada data pembayaran.</p>
        </div>
      ) : (
        <div className="space-y-2">
          {terfilter.map(p => {
            const s = STATUS_BAYAR_WARNA[p.status] || { bg: 'var(--bg-card3)', text: 'var(--text-muted)', label: p.status };
            return (
              <div key={p.id} className="rounded-xl p-4" style={{ backgroundColor: 'var(--bg-card2)', border: '1px solid var(--border)' }}>
                <div className="flex items-center justify-between mb-1">
                  <div>
                    <p className="font-semibold text-sm" style={{ color: 'var(--text-primary)' }}>{p.nama}</p>
                    <p className="text-xs" style={{ color: 'var(--text-muted)' }}>{p.email}</p>
                  </div>
                  <div className="text-right">
                    <p className="text-lg font-bold font-mono" style={{ color: 'var(--accent)' }}>{formatRupiahAdmin(p.jumlah)}</p>
                    <span className="text-[10px] font-semibold px-2 py-0.5 rounded-full" style={{ backgroundColor: s.bg, color: s.text }}>
                      {s.label}
                    </span>
                  </div>
                </div>
                <div className="flex items-center gap-1.5 mb-1">
                  <span className="text-[9px] font-semibold px-1.5 py-0.5 rounded uppercase"
                        style={{
                          backgroundColor: p.provider === 'tripay' ? 'rgba(96,165,250,0.15)' : p.provider === 'duitku' ? 'rgba(167,139,250,0.15)' : 'rgba(192,160,98,0.15)',
                          color: p.provider === 'tripay' ? '#60A5FA' : p.provider === 'duitku' ? '#A78BFA' : 'var(--accent)',
                        }}>
                    {p.provider === 'tripay' ? 'Tripay' : p.provider === 'duitku' ? 'Duitku' : 'Midtrans'}
                  </span>
                  {p.payment_method && (
                    <span className="text-[9px]" style={{ color: 'var(--text-faint)' }}>{p.payment_method}</span>
                  )}
                </div>
                <p className="text-xs" style={{ color: 'var(--text-muted)' }}>
                  {p.tryout_judul || `Tryout #${p.tryout_id}`} · {formatTgl(p.created_at)}
                </p>
                <p className="text-[10px] mt-1" style={{ color: 'var(--text-faint)' }}>{p.midtrans_order_id || p.tripay_reference || p.duitku_merchant_order_id}</p>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

// ─── Aktivitas Live (siapa yang sedang mengerjakan tes sekarang) ─
function hitungDurasi(mulai) {
  const detik = Math.floor((Date.now() - new Date(mulai).getTime()) / 1000);
  const menit = Math.floor(detik / 60);
  const sisaDetik = detik % 60;
  return menit > 0 ? `${menit} menit ${sisaDetik} detik` : `${sisaDetik} detik`;
}

function AktivitasLive({ token }) {
  const [aktif, setAktif]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [, setTick] = useState(0); // buat re-render durasi tiap detik

  useEffect(() => {
    const ambilData = () => {
      apiCall('/api/admin/aktivitas-live', 'GET', null, token)
        .then(data => { setAktif(data.aktif || []); setLoading(false); })
        .catch(() => setLoading(false));
    };
    ambilData();
    const pollInterval = setInterval(ambilData, 5000); // cek server tiap 5 detik
    const tickInterval = setInterval(() => setTick(t => t + 1), 1000); // update durasi tiap detik
    return () => { clearInterval(pollInterval); clearInterval(tickInterval); };
  }, [token]);

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-bold" style={{ color: 'var(--text-primary)', fontFamily: "'Poppins', sans-serif" }}>
          AKTIVITAS LIVE
        </h2>
        <span className="text-sm px-3 py-1 rounded-full flex items-center gap-1.5"
          style={{ backgroundColor: aktif.length > 0 ? 'rgba(74,222,128,0.15)' : 'var(--bg-card3)', color: aktif.length > 0 ? 'var(--success)' : 'var(--text-muted)' }}>
          {aktif.length > 0 && <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: 'var(--success)' }} />}
          {aktif.length} sedang aktif
        </span>
      </div>

      {loading ? (
        <p className="text-center py-8" style={{ color: 'var(--text-muted)' }}>Memuat...</p>
      ) : aktif.length === 0 ? (
        <div className="text-center py-12 rounded-xl" style={{ backgroundColor: 'var(--bg-card2)', border: '1px solid var(--border)' }}>
          <p className="text-4xl mb-3">💤</p>
          <p style={{ color: 'var(--text-muted)' }}>Belum ada user yang sedang latihan sekarang.</p>
        </div>
      ) : (
        <div className="space-y-2">
          {aktif.map(u => (
            <div key={u.userId} className="rounded-xl p-4"
              style={{ backgroundColor: 'var(--bg-card2)', border: `1px solid ${u.tryoutId ? 'var(--accent)' : 'var(--success)'}` }}>
              {u.tryoutId && (
                <div className="flex items-center gap-1.5 mb-2 pb-2" style={{ borderBottom: '1px solid var(--border)' }}>
                  <span className="text-xs">🏆</span>
                  <span className="text-xs font-bold uppercase tracking-wide" style={{ color: 'var(--accent)' }}>
                    Sedang Tryout — {u.tryoutJudul || `#${u.tryoutId}`}
                  </span>
                  <span className="text-xs font-mono ml-auto" style={{ color: 'var(--text-muted)' }}>
                    Modul {u.modulSelesai}/{u.totalModulTryout}
                  </span>
                </div>
              )}
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <span className="relative flex h-2.5 w-2.5">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full opacity-75" style={{ backgroundColor: u.tryoutId ? 'var(--accent)' : 'var(--success)' }} />
                    <span className="relative inline-flex rounded-full h-2.5 w-2.5" style={{ backgroundColor: u.tryoutId ? 'var(--accent)' : 'var(--success)' }} />
                  </span>
                  <div>
                    <p className="font-semibold text-sm" style={{ color: 'var(--text-primary)' }}>{u.nama}</p>
                    <p className="text-xs" style={{ color: 'var(--text-muted)' }}>{u.email}</p>
                  </div>
                </div>
                <div className="text-right">
                  <p className="text-sm font-semibold" style={{ color: 'var(--accent)' }}>
                    {MODUL_LABEL[u.modulId]?.icon || '📝'} {MODUL_LABEL[u.modulId]?.nama || u.modulId}
                  </p>
                  <p className="text-[11px]" style={{ color: 'var(--text-muted)' }}>sudah {hitungDurasi(u.mulai)}</p>
                  {u.skor != null && (
                    <p className="text-xs font-bold font-mono mt-0.5" style={{ color: 'var(--success)' }}>
                      Nilai: {u.skor}
                    </p>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ─── Log Aktivitas (riwayat siapa buka modul apa & kapan) ──────
function LogAktivitas({ token }) {
  const [log, setLog]         = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiCall('/api/admin/log-aktivitas', 'GET', null, token)
      .then(data => { setLog(data.log || []); setLoading(false); })
      .catch(() => setLoading(false));
  }, [token]);

  const durasiSelesai = (mulai, selesai) => {
    const detik = Math.floor((new Date(selesai) - new Date(mulai)) / 1000);
    const menit = Math.floor(detik / 60);
    const sisaDetik = detik % 60;
    return menit > 0 ? `${menit}m ${sisaDetik}d` : `${sisaDetik}d`;
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-bold" style={{ color: 'var(--text-primary)', fontFamily: "'Poppins', sans-serif" }}>
          LOG AKTIVITAS
        </h2>
        <span className="text-sm px-3 py-1 rounded-full" style={{ backgroundColor: 'var(--bg-card3)', color: 'var(--accent)' }}>
          {log.length} entri terbaru
        </span>
      </div>

      {loading ? (
        <p className="text-center py-8" style={{ color: 'var(--text-muted)' }}>Memuat log...</p>
      ) : log.length === 0 ? (
        <div className="text-center py-12 rounded-xl" style={{ backgroundColor: 'var(--bg-card2)', border: '1px solid var(--border)' }}>
          <p className="text-4xl mb-3">📜</p>
          <p style={{ color: 'var(--text-muted)' }}>Belum ada log aktivitas.</p>
        </div>
      ) : (
        <div className="space-y-2">
          {log.map(l => {
            const berlangsung = !l.selesai_at;
            return (
              <div key={l.id} className="rounded-xl p-3 flex items-center justify-between"
                   style={{ backgroundColor: 'var(--bg-card2)', border: `1px solid ${berlangsung ? 'var(--success)' : 'var(--border)'}` }}>
                <div className="flex items-center gap-3">
                  <span className="text-lg">{MODUL_LABEL[l.modul_id]?.icon || '📝'}</span>
                  <div>
                    <p className="font-semibold text-xs" style={{ color: 'var(--text-primary)' }}>{l.nama}</p>
                    <p className="text-[11px]" style={{ color: 'var(--text-muted)' }}>
                      {MODUL_LABEL[l.modul_id]?.nama || l.modul_id} · {formatTgl(l.mulai_at)}
                    </p>
                  </div>
                </div>
                <div className="text-right">
                  {berlangsung ? (
                    <span className="text-[10px] font-semibold px-2 py-0.5 rounded-full" style={{ backgroundColor: 'rgba(74,222,128,0.15)', color: 'var(--success)' }}>
                      ● Sedang berlangsung{l.skor != null ? ` · Nilai: ${l.skor}` : ''}
                    </span>
                  ) : (
                    <>
                      <span className="text-[11px] block" style={{ color: 'var(--text-muted)' }}>
                        durasi {durasiSelesai(l.mulai_at, l.selesai_at)}
                      </span>
                      {l.skor != null ? (
                        <span className="text-xs font-bold font-mono" style={{ color: 'var(--accent)' }}>Nilai: {l.skor}</span>
                      ) : (
                        <span className="text-[10px]" style={{ color: 'var(--text-faint)' }}>belum selesai/skor 0</span>
                      )}
                    </>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

// ─── Aktivitas User (gabungan Live + Harian + Tryout + Log) ────
function AktivitasUser({ token }) {
  const [subTab, setSubTab] = useState('live');
  return (
    <div className="space-y-4">
      <div className="flex gap-2 flex-wrap">
        {[
          { id: 'live', label: '🟢 Live' },
          { id: 'log', label: '📜 Log' },
          { id: 'harian', label: '📅 Latihan Harian' },
          { id: 'tryout', label: '🏆 Tryout' },
          { id: 'pembayaran', label: '💳 Pembayaran' },
        ].map(t => (
          <button key={t.id} onClick={() => setSubTab(t.id)}
            className="px-4 py-2 rounded-xl text-xs font-semibold transition"
            style={{
              backgroundColor: subTab === t.id ? 'var(--accent)' : 'var(--bg-card2)',
              color: subTab === t.id ? '#fff' : 'var(--text-muted)',
              border: '1px solid var(--border)',
            }}>
            {t.label}
          </button>
        ))}
      </div>
      {subTab === 'live' ? <AktivitasLive token={token} />
        : subTab === 'log' ? <LogAktivitas token={token} />
        : subTab === 'harian' ? <AktivitasHarian token={token} />
        : subTab === 'tryout' ? <HasilTryoutAdmin token={token} />
        : <PembayaranAdmin token={token} />}
    </div>
  );
}

// ─── Pembayaran Manual: verifikasi klaim transfer manual ───────
function PembayaranManualAdmin({ token }) {
  const [daftar, setDaftar] = useState([]);
  const [loading, setLoading] = useState(true);
  const [memproses, setMemproses] = useState(null); // id yang sedang diproses
  const [pesan, setPesan] = useState('');

  const muatData = () => {
    setLoading(true);
    apiCall('/api/admin/pembayaran-manual', 'GET', null, token)
      .then(data => { setDaftar(data.pembayaran || []); setLoading(false); })
      .catch(() => setLoading(false));
  };

  useEffect(() => { muatData(); }, [token]);

  const handleKonfirmasi = async (id) => {
    setMemproses(id);
    setPesan('');
    try {
      await apiCall(`/api/admin/pembayaran-manual/${id}/konfirmasi`, 'POST', null, token);
      setPesan('✓ Dikonfirmasi, akses dibuka & user dinotifikasi.');
      muatData();
    } catch {
      setPesan('Gagal mengonfirmasi.');
    }
    setMemproses(null);
  };

  const handleTolak = async (id) => {
    if (!window.confirm('Tolak klaim ini? User akan dinotifikasi transfer belum ditemukan.')) return;
    setMemproses(id);
    setPesan('');
    try {
      await apiCall(`/api/admin/pembayaran-manual/${id}/tolak`, 'POST', null, token);
      setPesan('Klaim ditolak.');
      muatData();
    } catch {
      setPesan('Gagal menolak klaim.');
    }
    setMemproses(null);
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-bold" style={{ color: 'var(--text-primary)', fontFamily: "'Poppins', sans-serif" }}>
          PEMBAYARAN MANUAL
        </h2>
        <span className="text-sm px-3 py-1 rounded-full" style={{ backgroundColor: 'var(--bg-card3)', color: 'var(--accent)' }}>
          {daftar.length} menunggu verifikasi
        </span>
      </div>

      <p className="text-xs" style={{ color: 'var(--text-muted)' }}>
        Cocokkan nominal unik di bawah dengan mutasi rekening Anda sebelum klik Konfirmasi. Klaim otomatis kedaluwarsa 24 jam kalau tidak diproses.
      </p>

      {pesan && (
        <p className="text-xs" style={{ color: pesan.startsWith('✓') ? 'var(--success)' : '#f87171' }}>{pesan}</p>
      )}

      {loading ? (
        <p className="text-sm" style={{ color: 'var(--text-muted)' }}>Memuat...</p>
      ) : daftar.length === 0 ? (
        <p className="text-sm" style={{ color: 'var(--text-muted)' }}>Tidak ada klaim yang menunggu verifikasi.</p>
      ) : (
        <div className="space-y-3">
          {daftar.map(p => (
            <div key={p.id} className="rounded-xl p-4" style={{ backgroundColor: 'var(--bg-card2)', border: '1px solid var(--border)' }}>
              <div className="flex items-center justify-between mb-2">
                <div>
                  <p className="text-sm font-semibold" style={{ color: 'var(--text-primary)' }}>{p.nama}</p>
                  <p className="text-xs" style={{ color: 'var(--text-muted)' }}>{p.email}</p>
                </div>
                <p className="text-xs" style={{ color: 'var(--text-faint)' }}>
                  {new Date(p.created_at).toLocaleString('id-ID', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })}
                </p>
              </div>
              <p className="text-xs mb-2" style={{ color: 'var(--text-muted)' }}>Tryout: {p.tryout_judul || `#${p.tryout_id}`}</p>
              <div className="rounded-lg px-3 py-2 mb-2" style={{ backgroundColor: 'var(--bg-card3)' }}>
                <p className="text-[10px] uppercase" style={{ color: 'var(--text-muted)' }}>Nominal Unik (cocokkan ke mutasi)</p>
                <p className="text-xl font-extrabold font-mono" style={{ color: 'var(--accent)' }}>{formatRupiahAdmin(p.nominal_transfer)}</p>
                <p className="text-[10px]" style={{ color: 'var(--text-faint)' }}>Harga tryout: {formatRupiahAdmin(p.jumlah)} + kode unik {p.kode_unik}</p>
              </div>
              {p.catatan_user && (
                <p className="text-xs mb-2 italic" style={{ color: 'var(--text-muted)' }}>Catatan user: "{p.catatan_user}"</p>
              )}
              <div className="flex gap-2">
                <button onClick={() => handleKonfirmasi(p.id)} disabled={memproses === p.id}
                  className="flex-1 py-2 rounded-lg text-xs font-semibold"
                  style={{ backgroundColor: 'var(--accent)', color: '#fff' }}>
                  {memproses === p.id ? 'Memproses...' : '✓ Konfirmasi Lunas'}
                </button>
                <button onClick={() => handleTolak(p.id)} disabled={memproses === p.id}
                  className="flex-1 py-2 rounded-lg text-xs font-semibold"
                  style={{ backgroundColor: 'rgba(220,38,38,0.1)', color: 'var(--danger)', border: '1px solid var(--danger)' }}>
                  ✕ Tolak
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ─── Notifikasi Push: monitoring subscriber + kirim manual ─────
function NotifikasiAdmin({ token }) {
  const [subscribers, setSubscribers] = useState([]);
  const [totalUserSubscribe, setTotalUserSubscribe] = useState(0);
  const [loading, setLoading] = useState(true);
  const [judul, setJudul] = useState('');
  const [pesan, setPesan] = useState('');
  const [targetUserId, setTargetUserId] = useState(''); // '' = broadcast semua
  const [mengirim, setMengirim] = useState(false);
  const [hasilKirim, setHasilKirim] = useState('');

  const muatData = () => {
    setLoading(true);
    apiCall('/api/admin/push/subscribers', 'GET', null, token)
      .then(data => {
        setSubscribers(data.subscribers || []);
        setTotalUserSubscribe(data.totalUserSubscribe || 0);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  useEffect(() => { muatData(); }, [token]);

  const handleKirim = async () => {
    if (!judul.trim() || !pesan.trim()) {
      setHasilKirim('Judul dan pesan wajib diisi.');
      return;
    }
    setMengirim(true);
    setHasilKirim('');
    try {
      await apiCall('/api/admin/push/kirim', 'POST', {
        userId: targetUserId || null,
        judul: judul.trim(),
        pesan: pesan.trim(),
      }, token);
      setHasilKirim('✓ Notifikasi berhasil dikirim.');
      setJudul('');
      setPesan('');
    } catch {
      setHasilKirim('Gagal mengirim notifikasi.');
    }
    setMengirim(false);
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-bold" style={{ color: 'var(--text-primary)', fontFamily: "'Poppins', sans-serif" }}>
          NOTIFIKASI PUSH
        </h2>
        <span className="text-sm px-3 py-1 rounded-full" style={{ backgroundColor: 'var(--bg-card3)', color: 'var(--accent)' }}>
          {totalUserSubscribe} user subscribe
        </span>
      </div>

      {/* Form kirim manual */}
      <div className="rounded-xl p-4 space-y-3" style={{ backgroundColor: 'var(--bg-card2)', border: '1px solid var(--border)' }}>
        <p className="text-xs font-semibold uppercase tracking-wider" style={{ color: 'var(--accent)' }}>Kirim Notifikasi Manual</p>

        <div>
          <label className="text-xs mb-1 block" style={{ color: 'var(--text-muted)' }}>Kirim ke</label>
          <select value={targetUserId} onChange={e => setTargetUserId(e.target.value)}
            className="w-full px-3 py-2 rounded-lg text-sm"
            style={{ backgroundColor: 'var(--bg-card3)', color: 'var(--text-primary)', border: '1px solid var(--border)' }}>
            <option value="">📢 Semua user (broadcast)</option>
            {subscribers.map(s => (
              <option key={s.user_id} value={s.user_id}>{s.nama} ({s.email})</option>
            ))}
          </select>
        </div>

        <div>
          <label className="text-xs mb-1 block" style={{ color: 'var(--text-muted)' }}>Judul</label>
          <input type="text" value={judul} onChange={e => setJudul(e.target.value)}
            placeholder="Contoh: Tryout Minggu Ini Sudah Dibuka!"
            className="w-full px-3 py-2 rounded-lg text-sm"
            style={{ backgroundColor: 'var(--bg-card3)', color: 'var(--text-primary)', border: '1px solid var(--border)' }} />
        </div>

        <div>
          <label className="text-xs mb-1 block" style={{ color: 'var(--text-muted)' }}>Pesan</label>
          <textarea value={pesan} onChange={e => setPesan(e.target.value)} rows={3}
            placeholder="Isi pesan notifikasi..."
            className="w-full px-3 py-2 rounded-lg text-sm resize-none"
            style={{ backgroundColor: 'var(--bg-card3)', color: 'var(--text-primary)', border: '1px solid var(--border)' }} />
        </div>

        <button onClick={handleKirim} disabled={mengirim}
          className="w-full py-2.5 rounded-lg font-semibold text-sm"
          style={{ backgroundColor: 'var(--accent)', color: '#fff' }}>
          {mengirim ? 'Mengirim...' : '🔔 Kirim Notifikasi'}
        </button>

        {hasilKirim && (
          <p className="text-xs text-center" style={{ color: hasilKirim.startsWith('✓') ? 'var(--success)' : '#f87171' }}>
            {hasilKirim}
          </p>
        )}
      </div>

      {/* Daftar subscriber */}
      <div>
        <p className="text-xs font-semibold uppercase tracking-wider mb-2" style={{ color: 'var(--accent)' }}>
          User yang Sudah Aktifkan Notifikasi
        </p>
        {loading ? (
          <p className="text-center py-6 text-sm" style={{ color: 'var(--text-muted)' }}>Memuat...</p>
        ) : subscribers.length === 0 ? (
          <div className="text-center py-10 rounded-xl" style={{ backgroundColor: 'var(--bg-card2)', border: '1px solid var(--border)' }}>
            <p className="text-3xl mb-2">🔕</p>
            <p className="text-sm" style={{ color: 'var(--text-muted)' }}>Belum ada user yang mengaktifkan notifikasi.</p>
          </div>
        ) : (
          <div className="space-y-1.5">
            {subscribers.map(s => (
              <div key={s.user_id} className="rounded-lg p-3 flex items-center justify-between"
                   style={{ backgroundColor: 'var(--bg-card2)', border: '1px solid var(--border)' }}>
                <div>
                  <p className="text-sm font-semibold" style={{ color: 'var(--text-primary)' }}>{s.nama}</p>
                  <p className="text-xs" style={{ color: 'var(--text-muted)' }}>{s.email}</p>
                </div>
                <span className="text-xs" style={{ color: 'var(--text-muted)' }}>{s.jumlah_device} device</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

// ─── Komponen Utama Admin Panel ───────────────────────────────
// ─── Kelola Kode Akses ────────────────────────────────────────
function KelolaKode({ token }) {
  const [kodes, setKodes]       = useState([]);
  const [loading, setLoading]   = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm]         = useState({ kode: '', keterangan: '', kuota: '100', expired_at: '' });
  const [error, setError]       = useState('');

  const loadKodes = useCallback(() => {
    apiCall('/api/admin/kode', 'GET', null, token)
      .then(data => { setKodes(data.kodes || []); setLoading(false); })
      .catch(() => setLoading(false));
  }, [token]);

  useEffect(() => { loadKodes(); }, [loadKodes]);

  const handleBuat = async () => {
    setError('');
    if (!form.kode) return setError('Kode wajib diisi');
    const data = await apiCall('/api/admin/kode', 'POST', form, token);
    if (data.kode) {
      setShowForm(false);
      setForm({ kode: '', keterangan: '', kuota: '100', expired_at: '' });
      loadKodes();
    } else {
      setError(data.error || 'Gagal membuat kode');
    }
  };

  const handleToggle = async (id, aktif) => {
    await apiCall(`/api/admin/kode/${id}`, 'PUT', { aktif: !aktif }, token);
    loadKodes();
  };

  const handleHapus = async (id, kode) => {
    if (!window.confirm(`Hapus kode "${kode}"?`)) return;
    await apiCall(`/api/admin/kode/${id}`, 'DELETE', null, token);
    loadKodes();
  };

  const salinKode = (kode) => {
    // Fallback untuk HTTP (belum HTTPS)
    try {
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(kode);
      } else {
        const el = document.createElement('textarea');
        el.value = kode;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
      }
      alert(`Kode "${kode}" berhasil disalin!`);
    } catch {
      alert(`Kode akses: ${kode}`);
    }
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-bold" style={{ color: 'var(--text-primary)', fontFamily: "'Poppins', sans-serif" }}>
          KELOLA KODE AKSES
        </h2>
        <button onClick={() => { setShowForm(!showForm); setError(''); }}
          className="px-4 py-2 rounded-xl text-sm font-semibold"
          style={{ backgroundColor: 'var(--accent)', color: 'var(--bg-app)' }}>
          + Buat Kode
        </button>
      </div>

      {/* Form buat kode */}
      {showForm && (
        <div className="rounded-xl p-5 space-y-3" style={{ backgroundColor: 'var(--bg-card2)', border: '1px solid var(--accent)' }}>
          <p className="font-bold text-sm" style={{ color: 'var(--accent)' }}>Buat Kode Akses Baru</p>

          {error && (
            <div className="px-3 py-2 rounded-lg text-xs" style={{ backgroundColor: 'rgba(220,38,38,0.1)', color: 'var(--danger)' }}>
              {error}
            </div>
          )}

          {[
            { key: 'kode', label: 'Kode Akses', type: 'text', placeholder: 'Contoh: BIMBEL2026', upper: true },
            { key: 'keterangan', label: 'Keterangan', type: 'text', placeholder: 'Untuk grup bimbel Pontianak' },
            { key: 'kuota', label: 'Kuota (max user)', type: 'number', placeholder: '100' },
            { key: 'expired_at', label: 'Expired (kosongkan = tidak ada batas)', type: 'date', placeholder: '' },
          ].map(f => (
            <div key={f.key}>
              <p className="text-xs uppercase tracking-wider mb-1" style={{ color: 'var(--text-muted)' }}>{f.label}</p>
              <input type={f.type} placeholder={f.placeholder}
                value={form[f.key]}
                onChange={e => setForm(prev => ({ ...prev, [f.key]: f.upper ? e.target.value.toUpperCase() : e.target.value }))}
                className="w-full px-3 py-2 rounded-lg text-sm focus:outline-none font-mono"
                style={{ backgroundColor: 'var(--bg-card)', color: 'var(--text-primary)', border: '1px solid var(--border)' }}
              />
            </div>
          ))}

          <div className="flex gap-3 pt-2">
            <button onClick={handleBuat}
              className="flex-1 py-2.5 rounded-xl font-bold text-sm"
              style={{ backgroundColor: 'var(--accent)', color: 'var(--bg-app)' }}>
              ✓ Buat Kode
            </button>
            <button onClick={() => { setShowForm(false); setError(''); }}
              className="flex-1 py-2.5 rounded-xl text-sm"
              style={{ backgroundColor: 'var(--bg-card3)', color: 'var(--text-muted)', border: '1px solid var(--border)' }}>
              Batal
            </button>
          </div>
        </div>
      )}

      {/* Daftar kode */}
      {loading ? (
        <p className="text-center py-8" style={{ color: 'var(--text-muted)' }}>Memuat kode akses...</p>
      ) : kodes.length === 0 ? (
        <div className="text-center py-12 rounded-xl" style={{ backgroundColor: 'var(--bg-card2)', border: '1px solid var(--border)' }}>
          <p className="text-4xl mb-3">🔑</p>
          <p style={{ color: 'var(--text-muted)' }}>Belum ada kode akses. Buat kode pertama!</p>
        </div>
      ) : (
        <div className="space-y-3">
          {kodes.map(k => {
            const pct = k.kuota > 0 ? Math.round((k.terpakai / k.kuota) * 100) : 0;
            const expired = k.expired_at && new Date(k.expired_at) < new Date();
            const habis = k.kuota > 0 && k.terpakai >= k.kuota;

            return (
              <div key={k.id} className="rounded-xl p-4"
                   style={{ backgroundColor: 'var(--bg-card2)', border: `1px solid ${k.aktif && !expired && !habis ? 'var(--accent)' : 'var(--border)'}` }}>
                <div className="flex items-start justify-between mb-3">
                  <div>
                    <div className="flex items-center gap-2 mb-1">
                      <p className="font-bold font-mono text-lg" style={{ color: 'var(--text-primary)' }}>{k.kode}</p>
                      <button onClick={() => salinKode(k.kode)}
                        className="text-xs px-2 py-0.5 rounded"
                        style={{ backgroundColor: 'var(--bg-card3)', color: 'var(--text-muted)' }}>
                        📋 Salin
                      </button>
                    </div>
                    {k.keterangan && <p className="text-xs" style={{ color: 'var(--text-muted)' }}>{k.keterangan}</p>}
                  </div>
                  <div className="flex items-center gap-2">
                    {(expired || habis) && (
                      <span className="text-xs px-2 py-0.5 rounded-full"
                            style={{ backgroundColor: 'rgba(220,38,38,0.1)', color: 'var(--danger)', border: '1px solid var(--danger)' }}>
                        {expired ? 'Expired' : 'Habis'}
                      </span>
                    )}
                    <span className="text-xs px-2 py-0.5 rounded-full"
                          style={{ backgroundColor: k.aktif ? 'var(--bg-card3)' : 'var(--bg-card3)', color: k.aktif ? 'var(--success)' : 'var(--text-muted)', border: '1px solid var(--border)' }}>
                      {k.aktif ? '● Aktif' : '○ Nonaktif'}
                    </span>
                  </div>
                </div>

                {/* Progress kuota */}
                <div className="mb-3">
                  <div className="flex justify-between text-xs mb-1" style={{ color: 'var(--text-muted)' }}>
                    <span>Pemakaian</span>
                    <span style={{ color: 'var(--text-primary)' }}>{k.terpakai} / {k.kuota > 0 ? k.kuota : '∞'} user</span>
                  </div>
                  {k.kuota > 0 && (
                    <div className="h-1.5 rounded-full" style={{ backgroundColor: 'var(--bg-card)' }}>
                      <div className="h-full rounded-full transition-all"
                           style={{ width: `${Math.min(pct, 100)}%`, backgroundColor: pct >= 100 ? 'var(--danger)' : pct >= 80 ? '#FBBF24' : 'var(--success)' }} />
                    </div>
                  )}
                </div>

                {/* Info expired */}
                {k.expired_at && (
                  <p className="text-xs mb-3" style={{ color: expired ? 'var(--danger)' : 'var(--text-muted)' }}>
                    {expired ? '⚠️ Expired: ' : '📅 Berlaku hingga: '}
                    {new Date(k.expired_at).toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' })}
                  </p>
                )}

                {/* Aksi */}
                <div className="flex gap-2">
                  <button onClick={() => handleToggle(k.id, k.aktif)}
                    className="flex-1 py-1.5 rounded-lg text-xs font-semibold"
                    style={{ backgroundColor: k.aktif ? 'rgba(220,38,38,0.1)' : 'var(--bg-card3)', color: k.aktif ? 'var(--danger)' : 'var(--success)', border: '1px solid var(--border)' }}>
                    {k.aktif ? 'Nonaktifkan' : 'Aktifkan'}
                  </button>
                  <button onClick={() => handleHapus(k.id, k.kode)}
                    className="px-3 py-1.5 rounded-lg text-xs font-semibold"
                    style={{ backgroundColor: 'rgba(220,38,38,0.1)', color: 'var(--danger)', border: '1px solid var(--danger)' }}>
                    Hapus
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Info cara pakai */}
      <div className="rounded-xl p-4" style={{ backgroundColor: 'var(--bg-card3)', border: '1px solid var(--border)' }}>
        <p className="text-xs font-bold mb-2" style={{ color: 'var(--accent)' }}>💡 Cara Penggunaan</p>
        <p className="text-xs leading-relaxed" style={{ color: 'var(--text-muted)' }}>
          Bagikan kode akses ke calon user via WhatsApp atau grup. User harus memasukkan kode ini saat mendaftar.
          Tanpa kode yang valid, user tidak bisa membuat akun.
        </p>
      </div>
    </div>
  );
}

export default function AdminPanel() {
  const [token, setToken]   = useState(() => localStorage.getItem('adminToken'));
  const [user, setUser]     = useState(() => {
    try { return JSON.parse(localStorage.getItem('adminUser')); } catch { return null; }
  });
  const [menu, setMenu]     = useState('dashboard');
  const [stats, setStats]   = useState({});

  useEffect(() => {
    if (token) {
      apiCall('/api/admin/stats', 'GET', null, token)
        .then(data => setStats(data))
        .catch(() => {});
    }
  }, [token]);

  const handleLogin = (t, u) => { setToken(t); setUser(u); };

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
    setToken(null);
    setUser(null);
  };

  if (!token || !user) return <LoginAdmin onLogin={handleLogin} />;

  const MENU = [
    { id: 'dashboard', label: 'Dashboard', icon: '📊' },
    { id: 'user', label: 'Kelola User', icon: '👥' },
    { id: 'aktivitas', label: 'Aktivitas User', icon: '📈' },
    { id: 'tryout', label: 'Kelola Tryout', icon: '🏆' },
    { id: 'progres-tryout', label: 'Progres Tryout', icon: '📋' },
    { id: 'peringkat', label: 'Peringkat', icon: '🏆' },
    { id: 'kode', label: 'Kode Akses', icon: '🔑' },
    { id: 'pembayaran-manual', label: 'Pembayaran Manual', icon: '🏦' },
    { id: 'notifikasi', label: 'Notifikasi', icon: '🔔' },
  ];

  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--bg-app)' }}>

      {/* Header */}
      <div className="px-6 py-4 flex items-center justify-between" style={{ backgroundColor: 'var(--bg-card)', borderBottom: '1px solid var(--border)' }}>
        <div className="flex items-center gap-3">
          <span className="text-xl">📊</span>
          <div>
            <p className="font-bold text-sm" style={{ color: 'var(--text-primary)', fontFamily: "'Poppins', sans-serif" }}>
              ADMIN PANEL
            </p>
            <p className="text-xs" style={{ color: 'var(--text-muted)' }}>Skortes</p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <p className="text-xs" style={{ color: 'var(--accent)' }}>👤 {user.nama}</p>
          <button onClick={handleLogout} className="text-xs px-3 py-1.5 rounded-lg"
                  style={{ backgroundColor: 'rgba(220,38,38,0.1)', color: 'var(--danger)', border: '1px solid var(--danger)' }}>
            Keluar
          </button>
        </div>
      </div>

      <div className="flex">
        {/* Sidebar */}
        <div className="w-48 min-h-screen p-4 space-y-1 flex-shrink-0" style={{ backgroundColor: 'var(--bg-card)', borderRight: '1px solid var(--border)' }}>
          {MENU.map(m => (
            <button key={m.id} onClick={() => setMenu(m.id)}
              className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium text-left transition"
              style={{
                backgroundColor: menu === m.id ? 'var(--bg-card3)' : 'transparent',
                color: menu === m.id ? 'var(--accent)' : 'var(--text-muted)',
                border: menu === m.id ? '1px solid var(--border)' : '1px solid transparent',
              }}>
              <span>{m.icon}</span> {m.label}
            </button>
          ))}
        </div>

        {/* Konten */}
        <div className="flex-1 p-6 max-w-3xl">
          {menu === 'dashboard' && <Dashboard token={token} stats={stats} />}
          {menu === 'user' && <KelolaUser token={token} />}
          {menu === 'aktivitas' && <AktivitasUser token={token} />}
          {menu === 'tryout' && <KelolaTryout token={token} />}
          {menu === 'progres-tryout' && <ProgresTryout token={token} />}
          {menu === 'peringkat' && <PeringkatAdmin token={token} />}
          {menu === 'kode' && <KelolaKode token={token} />}
          {menu === 'pembayaran-manual' && <PembayaranManualAdmin token={token} />}
          {menu === 'notifikasi' && <NotifikasiAdmin token={token} />}
        </div>
      </div>
    </div>
  );
}
